// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers, ElementRef, ViewChild, Renderer2,OnDestroy  } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material';

import 'rxjs/add/observable/forkJoin';

import { saveAs } from 'file-saver';

// Imports DIAN  
import { DError, DLogger, DMessageObsService, DRespuestaSimple, DValidaciones } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica, DDatosCompartidosCabecera, DItemRangoCasillas } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRenta210v18Servicios, DObjetoPagoPrimeraCuota, DRangosArt241ET, DDeclaracionSugerida, DTablaArt73, DTasaCambioCompleto } from '@dian-api/renta210v18'; //DObjetoEsResponsabilidad
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DArchivoBlob, DDocumento } from '@dian/api-formulario';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DDiligenciamientoParametricasServicios } from '@dian/api-diligenciamiento';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio, DParametrosPolitica, DParametroPolitica } from '@dian/api-basicos-parametricas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

// Imports App
import { DFormularioConfiguracion } from '../../../configuracion/dformulario-configuracion';
import { DPreguntasFormulario } from '../../../configuracion/dpreguntas-formulario';
import { DAyudasFormulario } from '../../../configuracion/dayudas-formulario';

import { DReciboPagoExteriorDialogoServicio } from '@dian-cmp/recibo-pago490-exterior';
import { GeneralDialogComponent } from '../../dialogos/general/general-dialog.component';
import { DialogsConfig } from '../../../configuracion/dialog-views-data';

import { NotificationsService } from '../../../services/notifications.service';
import { MessageObservableService } from '../../../services/message-observable.service';
import { DLiquidacionRecibo, DReciboPago490Servicios, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { DDevolucionesServicios,DDilDevolucionesObjeto,DDilvalidacionDevoluciones,DDilPersonaRutJSON } from '@dian-api/devoluciones';
import { SugeridaComponent } from '../../dialogos/sugerida/sugerida.component';
import { environment } from '../../../../environments/environment';
import { StepVertical } from '../../header-card-no-expertos/header-card-no-expertos.component';
import { SelectTabOption } from '../../tab/tab.component';
import { CopyModelService } from '../../../services/copy-model.service';
import { InitializeModelService } from '../../../services/Initialize-model.service';
import { DFormulario2100Configuracion } from '../../../configuracion/dformulario2100-configuracion';
import { ComponentFactoryService } from '../../../services/component-factory.service';
import { DevolucionesComponent } from '../../devoluciones/devoluciones.component';
import { Observable } from 'rxjs';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const optionsTabsFirma = [
  { id: 1, text: 'Pregunta(s) inicial(es)' },
  { id: 2, text: 'Diligenciamiento', clickable: true },
  { id: 3, text: 'Formulario 210', clickable: true },
  { id: 4, text: 'Firmar' },
  { id: 5, text: 'Presentar' },
  { id: 6, text: 'Pagar' }
];

const optionsTabsSinFirma = [
  { id: 1, text: 'Pregunta(s) inicial(es)' },
  { id: 2, text: 'Diligenciamiento', clickable: true },
  { id: 3, text: 'Formulario 210', clickable: true },
  { id: 4, text: 'Definitivo' },
  { id: 5, text: 'Pagar' }
];

let stepsList = [
 /* {
    id: 1, active: false, completed: false, icon: './assets/img/stepper-vertical/MisDatos.svg',
    title: 'Identificación', description: 'Algunos de los datos que encontrará aquí corresponden a la información registrada en la hoja principal de su RUT.'
  },
  {
    id: 2, active: false, completed: false, icon: './assets/img/stepper-vertical/MiPatrimonio.svg',
    title: 'Patrimonio', description: 'La suma de todos sus bienes materiales e inmateriales avaluados en dinero a diciembre 31 de 2023, sin restar deudas u obligaciones financieras.'
  },
  {
    id: 3, active: false, completed: false, icon: './assets/img/stepper-vertical/MisDeudas.svg',
    title: 'Deudas', description: 'El total de sus obligaciones en dinero con personas naturales y jurídicas en 2023.'
  },
  {
    id: 4, active: false, completed: false, icon: './assets/img/stepper-vertical/MisIngresos.svg',
    title: 'Ingresos', description: 'Todo lo que usted recibe en dinero y en especie, que aumentó su patrimonio en 2023.'
  },
  {
    id: 5, active: false, completed: false, icon: './assets/img/stepper-vertical/MisBeneficiosTributarios.svg',
    title: 'Beneficios tributarios', description: 'El total que la ley le permite restar del monto sobre el que va a calcular el impuesto de renta. '
  },
  {
    id: 6, active: false, completed: false, icon: './assets/img/stepper-vertical/MiImpuestoDeRenta.svg',
    title: 'Impuesto de renta', description: 'Es el aporte de cada contribuyente para garantizar los derechos fundamentales en Colombia.'
  }
  */
];


//Filtros
const DOCS_FILTER = ['11', '12', '13', '14', '21', '22', '31', '32', '41', '42'];

//Politicas
const POLITICA_1676	= "1676"; //Lista conceptos ingresos no gravados con renta
const POLITICA_1676_ORDER_FIELD = "codigo";
const POLITICA_1676_ORDER_TYPE = "asc";
const POLITICA_1674	= "1674"; //Lista anios extemporaneidad
const POLITICA_1673	= "1673"; //Lista anios declarados
const POLITICA_1672	= "1672"; //Tipos Rentas Líquidas Gravable
const POLITICA_1669 = "1669";
const POLITICA_1670 = "1670"; //Tipos Renta AFC
const POLITICA_1648 = "1648";//Moneda
const POLITICA_109 = "109";
const POLITICA_1630 = "1630"; //Tipos parentesco
const POLITICA_1630_ORDER_FIELD = "codigo";
const POLITICA_1630_ORDER_TYPE = "asc";
const POLITICA_1644 = "1644";
const POLITICA_1655 = "1655";
const POLITICA_1662 = "1662";
const POLITICA_1657 = "1657";
const POLITICA_1660 = "1660"; // Conceptos de ingreso Ganancia Ocasional
const POLITICA_1660_ORDER_FIELD = "codigo";
const POLITICA_1660_ORDER_TYPE = "asc";
const POLITICA_1661 = "1661"; // Conceptos de ingreso Ganancia Ocasional Herencia
const POLITICA_1661_ORDER_FIELD = "codigo";
const POLITICA_1661_ORDER_TYPE = "asc";
const POLITICA_1658 = "1658";
const POLITICA_1657_ORDER_FIELD = "codigo";
const POLITICA_1657_ORDER_TYPE = "asc";
const POLITICA_1658_ORDER_FIELD = "codigo";
const POLITICA_1658_ORDER_TYPE = "asc";
const POLITICA_1644_ORDER_FIELD = "codigo";
const POLITICA_1644_ORDER_TYPE = "asc";
const POLITICA_1659 = "1659";
const POLITICA_1659_ORDER_FIELD = "codigo";
const POLITICA_1659_ORDER_TYPE = "asc";
const VAL_PERIODICO_110 = 110;
const TIPO_REG_DECLARACION_SUG = '60600001';
const TIPO_REG_DECLARACION_SUG_FACTURA_RENTA = '60600002';
const POLITICA_1663 = "1663";
const POLITICA_1665 = "1665";
const POLITICA_1666 = "1666";
const POLITICA_1664 = "1664"
const POLITICA_GENERAL_ORDER_FIELD = "codigo";
const POLITICA_GENERAL_ORDER_TYPE = "asc";
const POLITICA_1667 = "1667" // Conceptos rentas exentas sin limitantes
const POLITICA_1667_ORDER_FIELD = "codigo";
const POLITICA_1667_ORDER_TYPE = "asc";
const POLITICA_318 = 318;
const POLITICA_1671	= "1671"; // Conceptos Rentas Exentas de Impuestos 
const POLITICA_1671_ORDER_FIELD = "codigo";
const POLITICA_1671_ORDER_TYPE = "asc";
//Mensajes
/*const MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY = `Para continuar, es necesario completar las casillas 286 y 24 
  teniendo en cuenta su situación económica y los datos del RUT. Además, considere la nueva clasificación de 
  actividades económicas CIIU, adaptada para Colombia por la DIAN mediante las Resoluciones Nro. 000114 del 21 de diciembre de 2020 y Nro. 001232 del 16 de septiembre de 2022.`;*/
const MESSAGES = {
  FACTURA_NO_CORREGIBLE: "La Factura de Renta no puede ser corregida",
  DILIGENCIA_CAS24: "Para continuar, seleccione una actividad económica de la casilla 24.",
  ES_MAYOR: "Superó tope indicativo relativo al art. 336-1 del E.T. marque casilla 303",
  SUMATORIA_MAYOR_A_INGRESOS: "La sumatoria de los valores reportados en las preguntas no puede superar la suma de los ingresos (cas. 32 + cas. 43 + cas. 58 + cas. 74)",
  GENERO_OBLIGATORIO: "Diligencie el género seleccionando uno de los elementos en la lista de la casilla 286",
  TARIFA_DIVIDENDOS: "Señor Contribuyente: Para liquidar el impuesto de dividendos conforme al inciso 2 del artículo 242 del Estatuto Tributario diligencie una de las siguientes tarifas 0 %, 5 %, 9 %, 15 %, 27 %, 33 %, 35 %, 38 %, 40 %, 45 %, 50 %, 8.75 %, 17.5 % y 26.25 % que le aplicaron como retención en la fuente al momento del pago.",
  APORTE_VOLUNTARIO:"Su aporte voluntario se destinará para programas sociales de reducción de la pobreza extrema al igual que para programas de atención a las personas en condición de discapacidad física, priorizando así la población socioeconómica más vulnerable",
  PRESENTADO:"Estimado(a) ciudadano(a) <br><br>Gracias al pago de sus impuestos, el Estado puede financiar proyectos sociales y obras de infraestructura pública que nos benefician a todos.<br>Ratificamos nuestra intención de hacer de la DIAN una entidad más ágil, eficiente, cercana y moderna, que le ayude a cumplir, de mejor manera, sus obligaciones tributarias.<br>Juntos trabajamos para trasformar a Colombia.<br><br><b>Luis Carlos Reyes</b><br>Director General",
  DEPENDIENTE:"El dependiente asociado a la deducción del 10%, debe ser igual a uno de los agregados en las casillas 242,288,291 o 294"
};



@Component({
  selector: 'app-formulario-no-experto',
  templateUrl: './formulario-no-experto.component.html',
  styleUrls: ['./formulario-no-experto.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio,
    DUtilidadesFormularioServicio,
    DRenta210v18Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DBasicosParametricasServicios,
    DReciboPagoExteriorDialogoServicio,
    DReciboPagoDialogoServicio,
    DReciboPago490Servicios,
    DDevolucionesServicios,
    ComponentFactoryService
  ]
})
export class FormularioNoExpertoComponent extends DFormulario implements OnInit {

  @ViewChild('focusable124') cas214Element: ElementRef;

  //dataError: any;
  //showDataError: boolean = false;

  public model2100: DDocumento = new DDocumento();
  public valorTrue = "1";
  public valorFalse = "0";
  public totalIngresos = "0";

  //Tab
  public optionsTabs: any[] = [];
  public indexSelectedTab: number = 0;

  //Preguntas Residente
  public preguntasContestadas: boolean = false;
  public tiempoPermanencia: string = "";
  public completoPeriodoPermanencia: string = "";
  public tieneNacionalidadColombiana: string = "";
  public servicioEstadoEnExterior: string = "";
  public ingresosJurisdiccionDomicilio: string = "";
  public activosJurisdiccionExterior: string = "";
  public esFamiliaResidenteFiscal: string = "";
  public ingresosFuenteNacional: string = "";
  public bienesAdministradosColombia: string = "";
  public activosPoseidosColombia: string = "";
  public noPuedeAcreditarResidenteExterior: string = "";
  public esResidenteParaisoFiscal: string = "";

  //Stepper
  public stepsList: StepVertical[] = stepsList;
  public indexStepper: number = 0;
  public validarRespuestaCambioTab: boolean = false;
  public habilitarSiguienteEnFirma: boolean = false;
  public documentoFirmado: boolean = false;

  //Recibo de pago
  public liquidacionRecigoPago: DLiquidacionRecibo = new DLiquidacionRecibo();
  public reciboPago: DRtaLiquidacionReciboPago = new DRtaLiquidacionReciboPago();

  public tiposDocumentofiltrado: Array<DValorDominio>;
  public tiposParentesco: Array<DValorDominio> = [];
  public tiposRentaAFC: Array<DValorDominio> = [];


  private tipoDeclaracion: boolean = true;
  private booFraccion: boolean = false;
  private booCas108: boolean = false;
  private booModifi2023: boolean = false;
  private booTopeindicativo: boolean = false;
  private actividadEconomica: any;
  private boolfinal = false;
  public boolAnticipos = false;
  private disponibilidad : boolean = true;
  


  // Variables  
  public ruta490: string = window.location.origin + '/WebDilIngresoFormReciboPago490';
  public ruta110: string = window.location.origin + '/WebDilIngresoFormRenta110';
  public UVT: string;
  private anioDeclaracion: number;
  private periodo: number;
  private parameters: any;
  private cuentadependientes:number=0;
  private tiposDocumento: Array<DValorDominio>;
  public listaGenero = [];
  public listaMoneda = [];
  public listaModoAdquision = [];
  public listaTipRentaAFC = [];
  public lisTipDeudaMonNal = [];
  public listaConceptosIng = [];
  public listaConcepIngresoGO = [];
  public listaActiIng = [];
  public listaTipoPension = [];
  public listaIngGOHerencia = [];
  public lisTipRentaPasivaECE = [];
  public listaConcDeduEspe = [];
  public listaAnioConstLiq = [];
  public listConcDescTrib = [];
  public listaConcpRentaExenSinLimite = [];
  public conceptosRentasExentas = [];
  public listaPoliticas: DParametrosPolitica = new DParametrosPolitica();
  public parametroPoliticaAFC : DParametroPolitica = new DParametroPolitica;
  public listaTipoCompensaciones: DValorDominio[] = [];
  public listaTiposRentasLiquidasGravables: DValorDominio[] = [];
  public listaAniosDeclarados: DValorDominio[] = [];
  public listaConceptosIngreNoGravados: DValorDominio[] = [];
  public listaAniosExtemporaneidad: DValorDominio[] = [];
  public habilitaDevoluciones: boolean = false;
  //Declaración sugerida
  public declaracionSugerida: any;
  //public declaracionSugeridaTO: any;
  private tienePrimeraCuota: DObjetoPagoPrimeraCuota;
  //casillas casillasDinamicas
  private casillasDinamicas: any;
  //actividadesEconomicas
  //private listaActividadesEconomicas: DActividadesEconomicas;
  public listaActividadesEconomicasVigentes = [];
  //Rangos Articulo 241 Estatuto Tributario  
  private rangosArt241ET: any;
  private rangosArt241ETNumeral2: any;
  private rangosArt241ETInciso1: any;
  private tabla1: any;
  private tabla2: any;
  private tablaArt73: any;
  public esDecretoMocoa: boolean;
  private temporal41: string;
  private temporal53: string;
  private temporal69: string;
  private temporal86: string;
  private modo='';
  private email;
  private strResponabilidad:string;
  private strHistoricoEstado:string;
  private personaRUTJSON:DDilPersonaRutJSON;

  private cambioFirma: boolean = true;
  //private contador: Number = 0;

  private tarifaA: string;
  private tarifaB: string;
  private strDividendosOtros: string;
  private porcDividendos = ['0', '5', '9', '15', '27', '33', '35', '38', '40', '45', '50', '8.75', '17.5', '26.25'];

  private calcularCas121: boolean = true;
  public mensajeIconoSugerida: string = 'Consultar Declaración sugerida';

  private dataHelps: any[] = [];

  habilitaDependiente2: boolean = true;
  habilitaDependiente3: boolean = true;
  habilitaDependiente4: boolean = true;
  habilitaDependiente5: boolean = true;
  
  infoCargada =false;

  //private configDocument = new DFormularioConfiguracion();
  private isFirstTime = true;
  isCompletedForm: boolean = false;
  //loadingResume: boolean = false;
  private suma500='0';
  dependiente10: boolean = false;

  constructor(
    dialog: MatDialog,
    router: Router,
    dNotificacionServicio: DNotificacionServicio,
    dPreguntasDialogoServicio: DPreguntasDialogoServicio,
    activatedRoute: ActivatedRoute,
    dutilidades: DOperacionesMatematicasServicio,
    utilitariosForm: DUtilidadesFormularioServicio,
    dlogger: DLogger,
    private dContextoUsuario: DContextoUsuarioServicio,
    private dRutServicios: DRutServicios,
    private dServicioRESTAPI: DRenta210v18Servicios,  // Servicio de ejemplo (debe ser cambiado por el del api del formulario correspondiente),
    private dServiciosDiliParametricas: DDiligenciamientoParametricasServicios,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    private dReciboPago: DReciboPagoDialogoServicio,
    private dReciboPagoExteriorDialogoServicio: DReciboPagoExteriorDialogoServicio,
    differ: KeyValueDiffers,
    private _location: Location,
    private helps: DAyudasFormulario,
    private _notifications: NotificationsService,
    private _messagesObs: MessageObservableService,
    private _restPago: DReciboPago490Servicios,
    private _restDevolucion:DDevolucionesServicios,
    private el: ElementRef,
    private _coreMessagesObs: DMessageObsService,
    private _componentFactory: ComponentFactoryService
  ) {
    super(
      router,
      activatedRoute,
      dialog,
      dContextoUsuario,
      dNotificacionServicio,
      dPreguntasDialogoServicio,
      dutilidades,
      utilitariosForm,
      dRutServicios,
      dServicioRESTAPI,
      new DFormularioConfiguracion(),
      new DPreguntasFormulario(),
      dlogger,
      differ,
      dServiciosDiliParametricas,
      dReciboPago,
      _coreMessagesObs
    );

    this.dataHelps = helps.AYUDAS_FORMULARIO[0].ayudas;
    this.casillasDinamicas = {
      cs_id_980: { disabled: false },
      cs_id_95: { disabled: false }
    }
    this.tienePrimeraCuota = null;
    this.declaracionSugerida = null;
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
    this.rangosArt241ETNumeral2 = DRangosArt241ET.NUMERAL_2;
    this.rangosArt241ETInciso1 = DRangosArt241ET.INCISO_1;
    this.tabla1 = DRangosArt241ET.TABLA1;
    this.tabla2 = DRangosArt241ET.TABLA2;
    this.tablaArt73 = DTablaArt73.TABLA_ART_73;
    this.esDecretoMocoa = false;  
      
  }


  ngOnInit() {  
    setTimeout(() => this.consultarFirmanteElectronico('desconocido'), 50);     //Esta linea inicia todo el proceso de la clase abstracta    
    this.activatedRoute.queryParams.subscribe((params: Params) => this.parameters = params);
    this.listenMessagesObs();
    this.listenCoreMessagesObs();
    this.indexSelectedTab = 0;
  }

  protected onInitFormulario() {
    this.anioDeclaracion = Number(this.modelo.doc.cab.cs_id_1);
    this.stepsList = [
      {
        id: 1, active: false, completed: false, icon: './assets/img/stepper-vertical/MisDatos.svg',
        title: 'Identificación', description: 'Algunos de los datos que encontrará aquí corresponden a la información registrada en la hoja principal de su RUT.'
      },
      {
        id: 2, active: false, completed: false, icon: './assets/img/stepper-vertical/MiPatrimonio.svg',
        title: 'Patrimonio', description: 'La suma de todos sus bienes materiales e inmateriales avaluados en dinero a diciembre 31 de '+this.anioDeclaracion+', sin restar deudas u obligaciones financieras.'
      },
      {
        id: 3, active: false, completed: false, icon: './assets/img/stepper-vertical/MisDeudas.svg',
        title: 'Deudas', description: 'El total de sus obligaciones en dinero con personas naturales y jurídicas en '+this.anioDeclaracion+'.'
      },
      {
        id: 4, active: false, completed: false, icon: './assets/img/stepper-vertical/MisIngresos.svg',
        title: 'Ingresos', description: 'Todo lo que usted recibe en dinero y en especie, que aumentó su patrimonio en '+this.anioDeclaracion+'.'
      },
      {
        id: 5, active: false, completed: false, icon: './assets/img/stepper-vertical/MisBeneficiosTributarios.svg',
        title: 'Beneficios tributarios', description: 'El total que la ley le permite restar del monto sobre el que va a calcular el impuesto de renta. '
      },
      {
        id: 6, active: false, completed: false, icon: './assets/img/stepper-vertical/MiImpuestoDeRenta.svg',
        title: 'Impuesto de renta', description: 'Es el aporte de cada contribuyente para garantizar los derechos fundamentales en Colombia.'
      }
      
    ];
    if (!this.modelo.doc.cab.cs_id_4 || this.modelo.doc.cab.cs_id_4 < 0) {
      this.verificaDisponiblidad();
      if(this.disponibilidad)
      {
        this.guardarBorradorInicial();
      }
    }
    this.procesarSinNotificaciones = true; //Previene mostrar las notificaciones o precarga del guardado automatico
    this.optionsTabs = this.firmaRequerida ? optionsTabsFirma : optionsTabsSinFirma;

    this._messagesObs.sendMessages('init-tabs', { tabs: this.optionsTabs, index: this.indexSelectedTab });


    
    this.periodo = Number(this.modelo.doc.cab.cs_id_3);
    this.modelo.doc.cab.cs_id_12 = Number(this.modelo.doc.cab.cs_id_12);

    //Se castea la variable boolean de la casilla 994
    if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false")
      this.modelo.doc.pie['cs_id_994'] = false;
    if (this.dDatosCompartidosCabecera.concepto === "fraccion" || this.dDatosCompartidosCabecera.concepto === "fraccion_correccion")
      this.booFraccion = true;
    
      if (this.modelo.doc.cuerpo['cs_id_285'] == 'true' && this.dDatosCompartidosCabecera.concepto == "correccion") {
      let notificaError = this._notifications.showError(MESSAGES.FACTURA_NO_CORREGIBLE);
      notificaError.afterClosed().subscribe(result => this._location.back());
    }

    //disable 980 pago total
    if (this.firmaRequerida) {
      this.casillasDinamicas.cs_id_980.disabled = true;
      this.modelo.doc.pie.cs_id_980 = "0";
    } else this.casillasDinamicas.cs_id_980.disabled = false;

    this.temporal41 = this.modelo.doc.cuerpo.cs_id_41;
    this.temporal53 = this.modelo.doc.cuerpo.cs_id_53;
    this.temporal69 = this.modelo.doc.cuerpo.cs_id_69;
    this.temporal86 = this.modelo.doc.cuerpo.cs_id_86;

    if (!this.modelo.doc.cuerpo['cs_id_284'])
      this.modelo.doc.cuerpo.cs_id_284 = "1";

    this.modelo.doc.cuerpo.cs_id_27 =
      this.dDatosCompartidosCabecera.concepto === "fraccion" ||
        this.dDatosCompartidosCabecera.concepto === "fraccion_correccion" ? "1" : "0";

    //Set value genero
    this.model2100.doc.cuerpo.cs_id_673 = this.modelo.doc.cuerpo.cs_id_286;
    this.modo=this.dDatosCompartidosCabecera.modo;
    //this.validateStateForm(true);
    this.calcularTarifasAB();
    //Mostrar datos del formulario
    this._messagesObs.sendMessages('info-form', this.dDatosCompartidosCabecera);
    this._messagesObs.sendMessages('tiene-firma', this.firmaRequerida);

    this.copyHeader();
    this.getDataForm();
   // this.dividendosOtros(14);
    this.cargarModel2100();
   // this.validateGetSugerida();
  }

  protected onInitCuestionario(respuestas: any) { }

  protected onChangeModelo(attrModelo: any) { }

  protected eventFormulario(evento: string) {
    if (evento === 'atributos_cargados') {
      this.validateStateForm();

      if (!this.isFirstTime) return;

      if (this.atributosDocumento.docAtributos.esPresentado) {
        //this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.PRESENTADO);
        this.showPresentado();
        this.indexSelectedTab = 5;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        return;
      }

      if (this.firmaRequerida && this.atributosDocumento.docAtributos.enProcesoFirmas) {
        this.optionsTabs.map(item => {
          if (item.id == 2) item.clickable = false;
          return item;
        });
        this.indexSelectedTab = 3;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        return;
      }

      if (
        this.firmaRequerida && 
        this.atributosDocumento.docAtributos.enProcesoFirmas && 
        !this.atributosDocumento.docAtributos.esPresentado
      ) {
        this.indexSelectedTab = 5;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        return;
      }
        this.isFirstTime = false;
    }

    if (evento === 'definitivo_generado') {
      this.imprimirFormulario();
      this.liquidarPagarFormulario();
    }  

    if (evento === 'documento_firmado') {
      this.habilitarSiguienteEnFirma = true;
      this.documentoFirmado = true;
    }

    if (evento === 'documento_no_firmado')
      this.habilitarSiguienteEnFirma = false;

    if (evento === 'habilitar_form') {
      
    }

    if (evento === 'borrador_guardado' || evento === 'borrador_actualizado') {
      this.procesarSinNotificaciones = true;
    }

    /* Se valida la respuesta de la casilla 994 al actualizar el formulario  */
    if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
      this.modelo.doc.pie['cs_id_994'] = false;
    }
  }

  protected onUploadFiles(docs: DArchivoBlob[]) { }

  private listenCoreMessagesObs() {
    this._coreMessagesObs.getMessages().subscribe(res => {
      if (res.operation === 'refresh-token') {
        // this._notifications.showConfirm('Le quedan menos de 10 minutos de vigencia a su sesión, ¿desea continuar?').afterClosed().subscribe(res => {
        this._notifications.showConfirm('Han pasado 15 minutos de inactividad. ¿Desea continuar y guardar su progreso?',null,'Continuar y guardar').afterClosed().subscribe(res => {
          if (!res) return;
          this.refreshTokenService();
        });
      }

      
    });
  }

  private refreshTokenService(): void {
    const year = new Date().getFullYear() - 1;
    this.dServicioRESTAPI.refrescarSesion(String(year)).subscribe(
      res => console.log('Proceso de refreshToken realizado con exito', res),
      error => console.error('Proceso de refreshToken realizado con error', error)
    );
  }

  //Helpers
  private copyHeader() {
    this.model2100.doc.cab = this.modelo.doc.cab;
  }

  private copyModel() {
    //const config = this.configDocument.RANGO_CUERPO;
    const config = new DItemRangoCasillas(27, 141);
    const serviceCopyBody = new CopyModelService(config);
    this.modelo = serviceCopyBody.copyModel(this.model2100, this.modelo);
    this.modelo.doc.cuerpo.cs_id_286 = this.model2100.doc.cuerpo.cs_id_673;
    this.agregarCasillaFueradeRango();
  }

  setStateSection(id: number, state: boolean): void {
    const indexStep = this.stepsList.findIndex(item => item.id === id);
    this.stepsList[indexStep].completed = state;
    if (state) {
      if (id == 1) this.stepsList[indexStep].active = false; //Close section when is completed
      this.llenarHoja1_2100();
    }
    this._messagesObs.sendMessages('move-scroll', 40);
    this.validateAllSectionsIsCompleted();
  }

  private validateAllSectionsIsCompleted(): void {    
    let state = true;
    for (let item of this.stepsList) {
      if (!item.completed) {
        state = false;
        break;
      }
    }
    this.isCompletedForm = state;
  }


  llenarHoja1_2100(): void {
    this.patrimonio_2100();
    this.ingresos_2100();
    this.rentaTrabajo_2100();
    this.rentaHonorarios_2100();
    this.rentaCapital_2100();
    this.rentaNoLaboral_2100();
    this.rentaPensiones_2100();
    this.gananciaOcasional_2100();
    this.descuentoOtros_2100();
    this.dependientres_2100();
    this.dividendos_2100();
  }

  //Patrimonio 
  patrimonio_2100(): void {

    //Patrimonio Bruto (Terminado-Actualizado)
    const datosC29 = ['cs_id_152', 'cs_id_154', 'cs_id_156', 'cs_id_158', 'cs_id_160', 'cs_id_162', 'cs_id_164', 'cs_id_166', 'cs_id_174'];
    ///se elimina casilla  'cs_id_172', solicitud atendida 17-07-2024
    const cas29 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model2100, datosC29, true);
    this.model2100.doc.cuerpo.cs_id_29 = cas29;

    //Deudas (Terminado-Actualizado)
    const datosC30 = ['cs_id_168', 'cs_id_170',];
    const cas30 = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model2100, datosC30, true);
    this.model2100.doc.cuerpo.cs_id_30 = cas30;
  }

  //Calculo de casillas de ingresos e ingresos totales
  ingresos_2100(): void {
    let datos = [];
    let valor = "";

    //Ingresos Brutos - Rentas de trabajo
    //Ingresos Brutos - Rentas Honorarios
      //Cas 305
    
      valor = this.model2100.doc.cuerpo.cs_id_305;
      let cas762T_11_2='0';
      if(this.model2100.doc.cuerpo.cc_id_760.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_760[i].v) ===11 && Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===2)
          {
            cas762T_11_2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T_11_2, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }

      this.model2100.doc.cuerpo.cs_id_43 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T_11_2, valor);
  
       //Ingresos Brutos - rentas de capital (Terminado)
      //Cas 328 + ( SI Cas 623 = 3; 624) + (SI Cas 761 = 3 Y Cas 760 = 1, 2, 3, 4, 5, 6, 7, 8, 10 u 11; Cas 762)
      
      let cas625T = '0';
      let cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_760.length)
          for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
          {
            if( Number(this.model2100.doc.cuerpo.cc_id_760[i].v) !=9 && Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===3)
            {
              cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
            }
          }

      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas625T, this.model2100.doc.cuerpo.cs_id_328);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, valor);
      this.model2100.doc.cuerpo.cs_id_58 = valor;
  
      //Dividendos y participaciones 2016 y anteriores, y otros - Renta por dividendos  y participaciones
      //SI Cas 492 = 1; Cas 493
      
      let cas493T='0';
      if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===1)
          {
            cas493T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      valor = cas493T;
      this.model2100.doc.cuerpo.cs_id_104 = valor;

      //105 Ingresos no constitutivos de renta - Renta por dividendos  y participaciones
      cas493T='0';
      /*if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===1)
          {
            cas493T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }*/
      valor = cas493T;
      this.model2100.doc.cuerpo.cs_id_105 = valor;

      //1a. Subcédula año 2017 y siguientes num. 3 art. 49 E.T. - Renta por dividendos  y participaciones
      //Si Cas 492 = 2; Cas 493

      cas493T='0';
      if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===2)
          {
            cas493T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      valor = cas493T;
      this.model2100.doc.cuerpo.cs_id_107 = valor;


      //2a. Subcédula año 2017 y siguientes par. 2 art. 49 del E.T.) - Ren por dividendos  y participaciones
      //SI Cas 492 = 3; SUMA Cas Cas 493 CUANDO Cas 492 = 3 

     /* cas493T='0';
      if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===3)
          {
            cas493T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      valor = cas493T;
      this.model2100.doc.cuerpo.cs_id_108 = valor;*/

      //Renta líquida pasiva div. - ECE y/o recibidos del exterior - Renta por dividendos  y participaciones
      //SI Cas 760 = 11; 762  

      cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_760.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11 && Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===6)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===4)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_623.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_623.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_623[i].v)===6)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_625[i].v);
          }
        }
      valor = cas762T;
      this.model2100.doc.cuerpo.cs_id_109 = valor;

      //Rentas exentas de la casilla 109  - Renta por dividendos  y participaciones
      //SI Cas 760 = 11; 762

      cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_760.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11 && Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===6)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }
      valor = cas762T;
      this.model2100.doc.cuerpo.cs_id_110 = valor;
      
      

    //Total ingresos	
    const camposSuma = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74', 'cs_id_99', 'cs_id_104', 'cs_id_107', 'cs_id_108', 'cs_id_109', 'cs_id_111'];
    this.totalIngresos = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model2100, camposSuma, true);

  }
  
rentaTrabajo_2100() 
  {
    let datos = [];
    let valor = "";

      

      //Ingresos no constitutivos de renta  - Rentas de trabajo

      
      //Ingresos no constitutivos de renta  - Rentas de trabajo

      let cas685T='0';
      if(this.model2100.doc.cuerpo.cc_id_684.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_684.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===1)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===2)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===5)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===8)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===10)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===6)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
         /*  else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===3)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          } */
          
        }
        
      //valor = cas685T;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cs_id_676);
      this.model2100.doc.cuerpo.cs_id_33 = valor;

      //Renta líquida - Rentas de trabajo
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model2100.doc.cuerpo.cs_id_32, this.model2100.doc.cuerpo.cs_id_33);
      valor =  this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, "0")?valor:'0';
      this.model2100.doc.cuerpo.cs_id_34 = valor;
      
      
        /////Limitantes afc
     valor= this.model2100.doc.cuerpo.cs_id_702;
     this.model2100.doc.cuerpo.cs_id_35 = valor;
      
      //Rentas exentas -Otras rentas exentas - Rentas de trabajo

      let cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_761.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 
              && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) !=10)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
         
        }
      let cas700T = '0';
      if(this.model2100.doc.cuerpo.cc_id_698.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_698.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_698[i].v)===1 &&
          (Number(this.model2100.doc.cuerpo.cc_id_697[i].v)===1 || Number(this.model2100.doc.cuerpo.cc_id_697[i].v)===2 
          || Number(this.model2100.doc.cuerpo.cc_id_697[i].v)===3))
          {
              cas700T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas700T, this.model2100.doc.cuerpo.cc_id_699[i].v);
            
          }
        }
      let cas292_297T = '0';
      let cas699 ='0';
      if(this.model2100.doc.cuerpo.cc_id_297.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_297.length; i++) 
        {
          if(i>0)break;
          cas292_297T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas292_297T, this.model2100.doc.cuerpo.cc_id_297[i].v);
        }

      if(this.model2100.doc.cuerpo.cc_id_298)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_298.length; i++) 
          {
            cas292_297T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas292_297T, this.model2100.doc.cuerpo.cc_id_298[i].v);

          }
      if(this.model2100.doc.cuerpo.cc_id_698.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_698.length; i++) 
         {  
            if((Number(this.model2100.doc.cuerpo.cc_id_697[i].v) == 1 || Number(this.model2100.doc.cuerpo.cc_id_697[i].v) == 2 || Number(this.model2100.doc.cuerpo.cc_id_697[i].v) == 3)
                && Number(this.model2100.doc.cuerpo.cc_id_698[i].v) == 1 ){         
              cas699 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas699, this.model2100.doc.cuerpo.cc_id_699[i].v);
            } 
          }
      valor='0';
      valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas699, valor);
      valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, valor);      
      valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas292_297T, valor);
      this.model2100.doc.cuerpo.cs_id_36 = valor;
      
      //Rentas exentas - Total rentas exentas - Rentas de trabajo

      let cas298_297T = '0';
      if(this.model2100.doc.cuerpo.cc_id_292.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_292.length; i++) 
        {
          cas298_297T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas298_297T, this.model2100.doc.cuerpo.cc_id_298[i].v);
          
        }
        if(this.model2100.doc.cuerpo.cc_id_292.length)
          cas298_297T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas298_297T, this.model2100.doc.cuerpo.cc_id_297[0].v);
      
      valor = cas298_297T;  
      this.model2100.doc.cuerpo.cs_id_37 = valor;

      //Ded impu - Intereses de vivienda - Rentas de trabajo
      let cas719T = '0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_711[i].v)===1)
          {
            cas719T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas719T, this.model2100.doc.cuerpo.cc_id_719[i].v);
          }
        }
      valor = cas719T;
      this.model2100.doc.cuerpo.cs_id_38 = valor;

      //Ded impu - Otras deducciones imputables - Rentas de trabajo
      //SI Cas 712 = 1 Y  Cas 711 =  2 o 3 o 4  o 6 o 7;  Cas 720 + Cas 721 + Cas 722
      let cas720_721_722T = '0';

      let bool303 = false;
      if(this.model2100.doc.cuerpo.cc_id_303.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_303.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_303[i].v)===1 )
          {
            bool303 = true;
            break;
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===1 )
          {
            if(Number(this.model2100.doc.cuerpo.cc_id_711[i].v)>=2 && Number(this.model2100.doc.cuerpo.cc_id_711[i].v)<=5)
            {
              cas720_721_722T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_721_722T, this.model2100.doc.cuerpo.cc_id_713[i].v);
            }
            else
            if(Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===2)
            {
              if(Number(this.model2100.doc.cuerpo.cc_id_711[i].v)===5 && bool303)
              {
               cas720_721_722T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_721_722T, this.model2100.doc.cuerpo.cc_id_713[i].v);
              }
            }
            
          }
          
        }
      valor = cas720_721_722T;
      this.model2100.doc.cuerpo.cs_id_39 = valor;
  }

 

  //Renta honorarios
      rentaHonorarios_2100() {
        let datos = [];
        let valor = "";

      
      
      //Ing no constitutivos ren - Ren hon y comp serv pers sin cost y gast  y no ren exen Num 10 art 206 ET
      //(SI Cas 684=2 Y Cas 683=1; Cas 685) + ( SI Cas 684=2 Y Cas 683=2; Cas 685) + (SI Cas 684=2 Y Cas 683=3; Cas 685) ojo 322 ARL
      let cas685T ='0';
      if(this.model2100.doc.cuerpo.cc_id_684.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_684.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===2 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===1)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===2 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===2)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===2 &&  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===7)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
        }
      //valor = cas685T;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cs_id_677);

      this.model2100.doc.cuerpo.cs_id_44 = valor;
      
      //Cost y ded procedentes - Ren hon y comp serv pers suj cost y gast  y no ren exen N 10 art 206 ET
      //SI Cas 746 = 2; 747
      let cas747T='0';
      if(this.model2100.doc.cuerpo.cc_id_746.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_746.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_746[i].v)===2)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_747[i].v);
          }
        }

      valor = cas747T;
      this.model2100.doc.cuerpo.cs_id_45 = valor;
      
      //Ren e - A vol AFC, FVP y/o AVC - Ren hon y comp serv pers suj c y gast  y no ren exen N 10 a 206 ET
      //SI Cas 315 <= Cas 319; Cas 315; Cas 319 
     
      valor = this.model2100.doc.cuerpo.cs_id_703;
      this.model2100.doc.cuerpo.cs_id_47 = valor;

      //Ren exen - Otras rentas exentas - Ren hon y comp serv pers suj c y gast  y no ren exen N 10 a 206 ET
      //(SI Cas 698 = 2 Y 697 = 1 o 2 o  3 o  4 o  7 o 8; Cas 699) + Cas 314 + (SI Cas 761 = 2 Y 760 = 1; 762)
      let cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_760.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===2 
          && ( (Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11) ))
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }

      let cas729T = '0';
      if(this.model2100.doc.cuerpo.cc_id_729.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_729.length; i++) 
        {
            cas729T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas729T, this.model2100.doc.cuerpo.cc_id_729[i].v);
        }
      
      this.model2100.doc.cuerpo.cs_id_48 = cas762T;

      //Ded imp - Intereses de vivienda - Ren hon y comp serv pers suj c y gast  y no ren exen N 10 a 206 ET
      //SI Cas 711 = 1 Y Cas 712 = 2; Cas 719  
      
      let cas719T = '0';
      if(this.model2100.doc.cuerpo.cc_id_711.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_711.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_711[i].v)===1
              && Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===2)
          {
            cas719T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas719T, this.model2100.doc.cuerpo.cc_id_713[i].v);
          }
        }
      
      valor = cas719T;
      this.model2100.doc.cuerpo.cs_id_50 = valor;
      
      //Ded imput - Otras deduc. imp. - Ren hon y comp serv pers suj c y gast  y no ren exen N 10 a 206 ET
      
      
      let cas720_721_722T='0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===2 )
        {
          if(Number(this.model2100.doc.cuerpo.cc_id_711[i].v)>=2 && Number(this.model2100.doc.cuerpo.cc_id_711[i].v)<7)
          {
            cas720_721_722T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_721_722T, this.model2100.doc.cuerpo.cc_id_713[i].v);
            
          }
        }
      }
    valor = cas720_721_722T;
    this.model2100.doc.cuerpo.cs_id_51 = valor;
    
    //Comp por pérdidas - Ren hon y comp serv pers suj cost y gast  y no ren exen N 10 art 206 ET
    //SI Cas 789 = 2 Y Cas 790 = 2; Cas 791

      let cas791T = '0';
      if(this.model2100.doc.cuerpo.cc_id_789.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_789.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_789[i].v)===2
              && Number(this.model2100.doc.cuerpo.cc_id_790[i].v)===2)
          {
            cas791T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas791T, this.model2100.doc.cuerpo.cc_id_791[i].v);
          }
        }

      valor = cas791T;
      this.model2100.doc.cuerpo.cs_id_56 = valor;

  }

  operaciondependiente10xciento()
  {
    
    let cas715T = '0';
      if(this.model2100.doc.cuerpo.cc_id_715.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_715.length; i++) 
        {
          cas715T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas715T, this.model2100.doc.cuerpo.cc_id_715[i].v);
        }

    let sumaala51='0';
    let sumaala39 ='0';
    if(( Number(cas715T) >0)&& 
    (Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32)) >0 || 
     Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43)) >0) )
    {
      if(Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43))===0)
      {
        sumaala39=cas715T
      }
      else
      {
        const suma= this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_43, this.modelo.doc.cuerpo.cs_id_32);
        const porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, this.modelo.doc.cuerpo.cs_id_32, suma);
        sumaala39 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentaje, cas715T,true);
      }
    }
    sumaala51=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas715T, sumaala39);
    this.modelo.doc.cuerpo.cs_id_39 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_39,sumaala39,true); 
    this.modelo.doc.cuerpo.cs_id_51 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_51,sumaala51,true); 
    this.dependiente10=true;
    
    
    this.operacionCs40();
    this.operacionCs41();
    this.operacionCs270(false);

  }
  //Renta de capital
  rentaCapital_2100() {
    let datos = [];
    let valor = "";

     
      //Ingresos no constitutivos de renta - Rentas de capital
      //(SI Cas 684=3 Y Cas 683=1; Cas 685) + (SI Cas 684=3 Y Cas 683=2; Cas 685) 
      //+ (SI Cas 684=3 Y Cas 683=3; Cas 685) + (SI Cas 761 = 3 Y 760 = 1; 762)

      let cas333T = '0';
      let cas685T = '0';
      if(this.model2100.doc.cuerpo.cc_id_684.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_684.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===1)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===2)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===7)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===11)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
        }
      
      //valor = cas685T;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, cas333T);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model2100.doc.cuerpo.cs_id_678);
      this.model2100.doc.cuerpo.cs_id_59 = valor;
      
      //Costos y deducciones procedentes - Rentas de capital
      //SI Cas 746 = 3; Cas 747
      
      let cas747T = '0';
      if(this.model2100.doc.cuerpo.cc_id_746.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_746.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_746[i].v)===3)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_747[i].v);
          }
        }
      valor = cas747T;
      this.model2100.doc.cuerpo.cs_id_60 = valor;
      //Rentas líquidas pasivas - Rentas de capital
      //SI Cas 623 = 3; 624

      let cas624T='0';
      if(this.model2100.doc.cuerpo.cc_id_623.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_623.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_623[i].v)===3)
          {
            cas624T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas624T, this.model2100.doc.cuerpo.cc_id_625[i].v);
          }
        }
      valor = cas624T;
      this.model2100.doc.cuerpo.cs_id_62 = valor;
      
      //Rentas exentas - Aportes voluntarios AFC, FVP y/o AVC - Rentas de capital
      //  SI Cas 698 = 3 Y 697 = 8 Y Cas 699 < Cas 702; Cas 699; SI_NO 702

     
      valor = valor = this.model2100.doc.cuerpo.cs_id_704;
      this.model2100.doc.cuerpo.cs_id_63 = valor;
      
      //Rentas exentas - Otras rentas exentas - Rentas de capital
      //(SI Cas 761 = 3 Y 760 = 1; 762)
      let cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_761.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) ===11)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }
      
      valor = cas762T;
      //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cs_id_730);
      this.model2100.doc.cuerpo.cs_id_64 = valor; 
      
      //Deducc imput - Intereses de vivienda - Rentas de capital
      //SI Cas 712 = 3 Y  Cas 711 = 1 ; 719
      
      let cas719T='0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_711[i].v)===1)
          {
            cas719T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas719T, this.model2100.doc.cuerpo.cc_id_719[i].v);
          }
        }
      valor = cas719T;
      
      this.model2100.doc.cuerpo.cs_id_66 = valor; 

      //Deducc imput - Otras deducciones imputables - Rentas de capital
      //SI Cas 712 = 3 Y Cas 711 =   2 o 3 o 4  o 6 o 7;  Cas 720 + Cas 721 + Cas 722
      let cas720_721_722='0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===3 && 
          (Number(this.model2100.doc.cuerpo.cc_id_711[i].v)>=2 || Number(this.model2100.doc.cuerpo.cc_id_711[i].v) <=7))
          {
            cas720_721_722 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_721_722, this.model2100.doc.cuerpo.cc_id_713[i].v);
          }
        }
      valor = cas720_721_722;
      this.model2100.doc.cuerpo.cs_id_67 = valor; 
      
      //Compensaciones por pérdidas - Rentas de capital
      //SI Cas 790 = 3 Y Cas 789 = 2; 791

      let cas791T='0';
      if(this.model2100.doc.cuerpo.cc_id_790.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_790.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_790[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_789[i].v)===2)
          {
            cas791T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas791T, this.model2100.doc.cuerpo.cc_id_791[i].v);
          }
        }
      valor = cas791T;
      this.model2100.doc.cuerpo.cs_id_72 = valor; 


  }

  //Renta no laboral
  rentaNoLaboral_2100() {
    let datos = [];
    let valor = "";
    //Ingresos brutos - Rentas no laborales
    //Cas 343 + (Si 547 > 2021; Cas 538) + ( SI Cas 514 > 2021; 509) + ( SI Cas 574 >  2021; 566) + (SI Cas 761 = 4 Y 760 = 10; 762)
    // + (SI Cas 760 = 10; Cas 762) + ( SI Cas 623 = 4; 624) + Cas 648

      let cas74T='0';
      
      if(this.model2100.doc.cuerpo.cc_id_547.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_547.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)>=2021)
          {
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_538[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_514.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_514.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_514[i].v)>=2021)
          {
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_509[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_574.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_574.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_574[i].v) < 4 )
          {
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_566[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_761.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
        {
          if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===4 && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===10) ||
              (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===4 && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11))
          {
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
         
        }
      
        
      if(this.model2100.doc.cuerpo.cc_id_683.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_683.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===10
              || Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===9)
          {
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else
          {
            if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4
            &&(Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===4 || Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===6))
            {
              cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas74T, this.model2100.doc.cuerpo.cc_id_685[i].v);
            }

          }
        }
        
      // cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model2100.doc.cuerpo.cs_id_343, cas74T, true);
      if (this.model2100.doc.cuerpo.cc_id_342.length>0) {
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_342.length; i++) 
        {
          cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model2100.doc.cuerpo.cc_id_342[i].v, cas74T, true);
        }
      }

      if (this.model2100.doc.cuerpo.cc_id_370.length>0) {
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_370.length; i++) 
        {
          if(Number(this.model2100.doc.cuerpo.cc_id_370[i].v)===4){
            cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model2100.doc.cuerpo.cc_id_371[i].v, cas74T, true);
          }
        }
      }
      cas74T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model2100.doc.cuerpo.cs_id_648, cas74T, true);
      valor = cas74T;
      this.model2100.doc.cuerpo.cs_id_74 = valor;

      //Devoluciones, rebajas y descuentos - Rentas no laborales
      //valor = this.model2100.doc.cuerpo.cs_id_347;
      valor='0';
      if(this.model2100.doc.cuerpo.cc_id_347.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_347.length; i++) 
      {
          valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model2100.doc.cuerpo.cc_id_347[i].v);
        
      }
      this.model2100.doc.cuerpo.cs_id_75 = valor;
      
      //Ingresos no constitutivos de renta - Rentas no laborales
      //(SI Cas 684=4 Y Cas 683=1; Cas 685) + (SI Cas 684=4 Y Cas 683=2; Cas 685) + (SI Cas 684=4 Y Cas 683=3; Cas 685) + 
      //(SI Cas 591 = 3; Cas 585)
      let cas685T='0';
      let cas678T='0'; 
      let cas555T='0';
      if(this.model2100.doc.cuerpo.cc_id_684.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_684.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4 &&  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===1)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4 &&  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===2)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4 &&  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===6)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if( Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4 && Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===10)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if(  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===3 && Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if(  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===9 )
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          else 
          if(  Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===4 && Number(this.model2100.doc.cuerpo.cc_id_684[i].v)===4)
          {
            cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas685T, this.model2100.doc.cuerpo.cc_id_685[i].v);
          }
          
        }

      if(this.model2100.doc.cuerpo.cc_id_547.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_547.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)>=2021 && Number(this.model2100.doc.cuerpo.cc_id_537[i].v)==3)
          {
            cas555T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas555T, this.model2100.doc.cuerpo.cc_id_555[i].v);
          }
        }
      valor=cas685T;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model2100.doc.cuerpo.cs_id_679, valor);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas555T);
      this.model2100.doc.cuerpo.cs_id_76 = valor;

      //Costos y deducciones procedentes - Rentas no laborales
      //SI Cas 746 = 4; Cas 747
      let cas747T='0';
      if(this.model2100.doc.cuerpo.cc_id_746.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_746.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_746[i].v)===4)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_747[i].v);
          }
        }
        if(this.model2100.doc.cuerpo.cc_id_514.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_514.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_514[i].v)>=2021)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_510[i].v);
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_547.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_547.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)>=2021)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_553[i].v);
          }
        }
        // agregado 11 agosto 2024
      if(this.model2100.doc.cuerpo.cc_id_574.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_574.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_574[i].v)<4)
          {
            cas747T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas747T, this.model2100.doc.cuerpo.cc_id_569[i].v);
          }
        }
      valor = cas747T;
      this.model2100.doc.cuerpo.cs_id_77 = valor;
      //Rentas líquidas pasivas - Rentas no laborales
      //SI Cas 623 = 4; 624
      let cas624T='0';
      if(this.model2100.doc.cuerpo.cc_id_623.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_623.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_623[i].v)===4)
          {
            cas624T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas624T, this.model2100.doc.cuerpo.cc_id_625[i].v);
          }
        }
      valor = cas624T;
      this.model2100.doc.cuerpo.cs_id_79 = valor;
      
      //Rentas exentas - Aportes voluntarios AFC, FVP y/o AVC - Rentas no laborales
      //SI 698 = 4 Y 760 = 9; 699
      
      valor = valor = this.model2100.doc.cuerpo.cs_id_706;
      this.model2100.doc.cuerpo.cs_id_80 = valor;
      
      //Rentas exentas -,Otras rentas exentas - Rentas no laborales
      //(SI Cas 761 = 4 Y 760 = 1; 762) + (SI Cas 760 = 10; Cas 762)  

      let cas762T='0';
      if(this.model2100.doc.cuerpo.cc_id_761.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===4
              && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===10)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
          else
          if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===4
              && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11)
          {
            cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
          }
        }
     
      valor = cas762T;
      //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cs_id_731);
      this.model2100.doc.cuerpo.cs_id_81 = valor;

      //Deducciones imputables - Intereses de vivienda - Rentas no laborales
      //SI Cas 712 = 4 Y  Cas 711 = 1 ; Cas 719

      let cas713T='0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===4
              && Number(this.model2100.doc.cuerpo.cc_id_711[i].v)===1)
          {
            cas713T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas713T, this.model2100.doc.cuerpo.cc_id_713[i].v);
          }
        }
      valor = cas713T;
      this.model2100.doc.cuerpo.cs_id_83 = valor;

      //Deducciones imputables - Otras deducciones imputables- Rentas no laborales
      //SI Cas 712 = 4 Y Cas 711 =  3 o 4  o 6 o 7; Cas 720 + Cas 721 + Cas 722

      let cas720_713T='0';
      if(this.model2100.doc.cuerpo.cc_id_712.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_712.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_712[i].v)===4
              && (Number(this.model2100.doc.cuerpo.cc_id_711[i].v) >= 1 || Number(this.model2100.doc.cuerpo.cc_id_711[i].v) <=7) )
          {
            cas720_713T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_713T, this.model2100.doc.cuerpo.cc_id_720[i].v);
            cas720_713T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas720_713T, this.model2100.doc.cuerpo.cc_id_713[i].v);
          }
        }
      valor = cas720_713T;
      this.model2100.doc.cuerpo.cs_id_84 = valor;
      
      //Compensaciones por pérdidas - Rentas no laborales
      //SI Cas 790 = 4 Y Cas 789 = 2; 791

      let cas791T='0';
      if(this.model2100.doc.cuerpo.cc_id_790.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_790.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_790[i].v)===4
              && Number(this.model2100.doc.cuerpo.cc_id_789[i].v)===2)
          {
            cas791T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas791T, this.model2100.doc.cuerpo.cc_id_791[i].v);
          }
        }
      valor = cas791T;
      this.model2100.doc.cuerpo.cs_id_89 = valor;
  }

  //Renta de pensiones
  rentaPensiones_2100() {
    let datos = [];
    let valor = "";

    //Ingresos - rentas de pensiones (Terminado)
    let cas699T='0';
      if(this.model2100.doc.cuerpo.cc_id_699.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_699.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_697[i].v)===11 )
          {
            cas699T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas699T, this.model2100.doc.cuerpo.cc_id_699[i].v);
          }
        }

    let cas762T='0';
    if(this.model2100.doc.cuerpo.cc_id_761.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===5 && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11)
        {
          cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas699T, this.model2100.doc.cuerpo.cs_id_355); 
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas762T); 
    this.model2100.doc.cuerpo.cs_id_99 = valor;

    //ingresos no constitutivos de renta - Renta de pensiones
    //Cas 360
    valor='0';
    if(this.model2100.doc.cuerpo.cc_id_360.length)
    for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_360.length; i++) 
    {
        valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, this.model2100.doc.cuerpo.cc_id_360[i].v);
      
    }
    this.model2100.doc.cuerpo.cs_id_100 = valor;

    //Rentas exentas de pensiones - Renta de pensiones
    //SI Cas 697 = 5 o 6; Cas 699
 
    let cas363_23='0'
    let cas363_14=[];
    if(this.model2100.doc.cuerpo.cc_id_363.length){
      if(this.model2100.doc.cuerpo.cc_id_363.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_363.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_353[i].v)===2 || Number(this.model2100.doc.cuerpo.cc_id_353[i].v)===3)
            cas363_23 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas363_23, this.model2100.doc.cuerpo.cc_id_363[i].v);
          else if(Number(this.model2100.doc.cuerpo.cc_id_353[i].v)===1 || Number(this.model2100.doc.cuerpo.cc_id_353[i].v)===4)
            cas363_14.push(this.model2100.doc.cuerpo.cc_id_363[i].v);
        }
    }

    
    cas762T='0';
    if(this.model2100.doc.cuerpo.cc_id_761.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===5 && Number(this.model2100.doc.cuerpo.cc_id_760[i].v)===11)
        {
          cas762T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas762T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    /* valor = cas699T; */
    let suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas363_23, cas363_14[0]);
    suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma, cas762T);

    this.model2100.doc.cuerpo.cs_id_102 = suma;
    
    
  }


  //Ganancia Ocasional
  gananciaOcasional_2100() {

    let datos = [];
    let valor = "";

    //Ingresos por ganancias ocasionales en el país y del exterior - Ganancia  ocasional
    //( SI Cas 514 <= 2021; Cas 509) + (Si 547 <= 2021; Cas 538) + ( SI Cas 574 <=  2021; 566)  + Cas 586 + Cas 608 + Cas 568
    
    let cas509T='0';
    let cas538T='0';
    let cas566T='0';
    let cas585T = '0';
    let cas685T = '0';
    
    if(this.model2100.doc.cuerpo.cc_id_514.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_514.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_514[i].v)<2021)
        {
          cas509T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas509T, this.model2100.doc.cuerpo.cc_id_509[i].v);
        }
      }
    if(this.model2100.doc.cuerpo.cc_id_547.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_547.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)<2021 && (Number(this.model2100.doc.cuerpo.cc_id_537[i].v)===1 || Number(this.model2100.doc.cuerpo.cc_id_537[i].v)===2 || Number(this.model2100.doc.cuerpo.cc_id_537[i].v)===3 ||Number(this.model2100.doc.cuerpo.cc_id_537[i].v)===4))
        {
          cas538T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas538T, this.model2100.doc.cuerpo.cc_id_538[i].v);
        }
      }
     
    if(this.model2100.doc.cuerpo.cc_id_574.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_574.length; i++) 
      {
        if(Number(this.model2100.doc.cuerpo.cc_id_574[i].v)===4)
        {
          cas566T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas566T, this.model2100.doc.cuerpo.cc_id_566[i].v);
        }
      }
      if(this.model2100.doc.cuerpo.cc_id_683.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_683.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_683[i].v)===8)
        {
          cas685T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas566T, this.model2100.doc.cuerpo.cc_id_685[i].v);
        }
      }
    
    let suma586='';
    if(this.model2100.doc.cuerpo.cc_id_584.length && this.model2100.doc.cuerpo.cc_id_591.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_584.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_584[i].v) >0 || Number(this.model2100.doc.cuerpo.cc_id_591[i].v)>0)
        {
          suma586 = 'cs_id_586';
          break;
        }
      }
    let cas521T='0';
    if(this.model2100.doc.cuerpo.cc_id_508.length)
    for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_508.length; i++) 
    {
      if( Number(this.model2100.doc.cuerpo.cc_id_508[i].v)===1
        && Number(this.model2100.doc.cuerpo.cc_id_514[i].v) < 2021)
      {
        cas521T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, this.model2100.doc.cuerpo.cc_id_521[i].v);
      }
    }
    valor='0';
    datos = [suma586, 'cs_id_608'];
    valor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model2100, datos, true);
    valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas509T);
    valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas538T);
    valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas566T);
    valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas685T);
    valor=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas521T);
    valor = this.dutilidades.deshacerFormatoMoneda(valor);
    this.model2100.doc.cuerpo.cs_id_112 = valor;

    //Costos por ganancias ocasionales - Ganancia  ocasional
    //SI Cas 522 < Cas 523 + Cas 524; Cas 522 ; SI_NO Cas 523 + Cas 524 

    let cas113T='0';
    if(this.model2100.doc.cuerpo.cc_id_510.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_510.length; i++) 
      {
        
        cas113T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,  cas113T,  this.model2100.doc.cuerpo.cc_id_510[i].v);
        
      }
    if(this.model2100.doc.cuerpo.cc_id_553.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_553.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)<2021 && (Number(this.model2100.doc.cuerpo.cc_id_537[i].v)>=1 && Number(this.model2100.doc.cuerpo.cc_id_537[i].v)<=4)){
          cas113T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,  cas113T,  this.model2100.doc.cuerpo.cc_id_553[i].v);
        }
        
      }
    if(this.model2100.doc.cuerpo.cc_id_574.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_574.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_574[i].v)==4)
        {
          cas113T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas113T, this.model2100.doc.cuerpo.cc_id_569[i].v);
        }
      }

      
    valor = cas113T;
    this.model2100.doc.cuerpo.cs_id_113 = valor;

    //Ganancias ocasionales no gravadas y exentas - Ganancia  ocasional
    //Cas 597 + Cas 595 + Cas 596 + Cas 598 + (SI 574 <= 2021; Cas 566) + (SI Cas 522 < Cas 523 + Cas 524; Cas 522; SI_NO Cas 523 + Cas 524) 
   
   //////////////////Nueva 114//////////////////////////////
   let cas522T = '0';
   if(this.model2100.doc.cuerpo.cc_id_522.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_522.length; i++) 
      {
        if (Number(this.model2100.doc.cuerpo.cc_id_522[i].v)>0
            && Number(this.model2100.doc.cuerpo.cc_id_514[i].v)<=1977)
          {
            cas522T = cas522T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas522T, this.model2100.doc.cuerpo.cc_id_522[i].v);
          }
          else if(Number(this.model2100.doc.cuerpo.cc_id_520[i].v)===1 && (Number(this.model2100.doc.cuerpo.cc_id_514[i].v)>1977 && Number(this.model2100.doc.cuerpo.cc_id_514[i].v)<1987)){
            cas522T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas522T, this.model2100.doc.cuerpo.cc_id_523[i].v);
            cas522T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas522T, this.model2100.doc.cuerpo.cc_id_524[i].v);
          }
          else if(Number(this.model2100.doc.cuerpo.cc_id_520[i].v)===1 && Number(this.model2100.doc.cuerpo.cc_id_514[i].v)>1986){
            cas522T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas522T, this.model2100.doc.cuerpo.cc_id_524[i].v);
          }
      }
    ///Suma 585 /////////////////////////////////////////////////////////////
    
      //////591
     if(this.model2100.doc.cuerpo.cc_id_585.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
          
          if((Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===1 || Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===2)
            && Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===3 )
          {
            cas585T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585T, this.model2100.doc.cuerpo.cc_id_585[i].v);
          }
        }
        if(this.model2100.doc.cuerpo.cc_id_585.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
          
          if(Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===3
            && Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===5 )
          {
            cas585T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585T, this.model2100.doc.cuerpo.cc_id_598[i].v);
          }
        }
        if(this.model2100.doc.cuerpo.cc_id_576.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_576.length; i++) 
        {
          
            cas585T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585T, this.model2100.doc.cuerpo.cc_id_576[i].v);
        } 
         
        let cas555T = '0';
        if(this.model2100.doc.cuerpo.cc_id_547.length)
          for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_547.length; i++) 
          {
            if( Number(this.model2100.doc.cuerpo.cc_id_547[i].v)<2021 &&  Number(this.model2100.doc.cuerpo.cc_id_537[i].v)===3) 
            {
              cas555T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas555T, this.model2100.doc.cuerpo.cc_id_555[i].v);
            }
          }
         
     
   /////////////////////////////////////////////////////////
    valor='0';    
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas522T, cas585T);
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas555T, valor);
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.operacion585con591(), valor);
    this.model2100.doc.cuerpo.cs_id_114 = valor;

    
  }

  operacion585con591()
  {
    
    ///Suma 585 /////////////////////////////////////////////////////////////
    let cas585T='0';
    let cas585C ='0';

    //////////////////////////////////////////////////////////////////////////////
     if(this.model2100.doc.cuerpo.cc_id_585.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
          
          if(Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===1 
             && (Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===1))
          {
            if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model2100.doc.cuerpo.cc_id_585[i].v,this.model2100.doc.cuerpo.cc_id_595[i].v))
            {
              cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_585[i].v);
            }
            else
            {
              cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_595[i].v);
            }
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_585.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
        
        if(Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===1 
            && (Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===2))
        {
          if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model2100.doc.cuerpo.cc_id_585[i].v,this.model2100.doc.cuerpo.cc_id_596[i].v))
            {
            cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_585[i].v);
            }
          else
          {
            cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_596[i].v);
          }
        }
      }
     
    //////////////////////////////////////////////////////////////////////////////

     if(this.model2100.doc.cuerpo.cc_id_585.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
          
          if(Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===2 
             && (Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===1))
          {
            if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model2100.doc.cuerpo.cc_id_585[i].v,this.model2100.doc.cuerpo.cc_id_595[i].v))
            {
              cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_585[i].v);
            }
            else
            {
              cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_595[i].v);
            }
          }
        }
      if(this.model2100.doc.cuerpo.cc_id_585.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
        {
        
        if(Number(this.model2100.doc.cuerpo.cc_id_591[i].v)===2 
            && (Number(this.model2100.doc.cuerpo.cc_id_584[i].v)===2))
        {
          if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model2100.doc.cuerpo.cc_id_585[i].v,this.model2100.doc.cuerpo.cc_id_596[i].v))
            {
            cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_585[i].v);
            }
          else
          {
            cas585C = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas585C, this.model2100.doc.cuerpo.cc_id_596[i].v);
          }
        }
      }

      const uvt3250 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, "3250", this.UVT);
      let suma597 = '0';
      if(this.model2100.doc.cuerpo.cc_id_585.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_585.length; i++) 
      {

         suma597 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma597, this.model2100.doc.cuerpo.cc_id_597[i].v);
      }
      suma597 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma597,uvt3250) ? suma597:uvt3250;
      cas585C =this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma597, cas585C);
      ////////////Compara la ganacia ocacional con el ingreso
      const compara=this.model2100.doc.cuerpo.cs_id_586;
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas585C,compara))
      {
        cas585T=cas585C;
      }
      else
      {
        cas585T=compara;
      }

    

    return cas585T;
  }

  descuentoOtros_2100() {
    let datos = [];
    let valor = "";

      //Rentas exentas y deducciones imputables limitadas - Cédula general
      //Calculo del 210 (SI Cas 760 = 1 o 2 o 3 o 4 o 5 o 6 o 7 o 8  o 9 ; Cas 762) + (SI Cas 761 = 2 Y 760 = 1; 762)

      /////////////casilla 92 es un calculo del 210 verificar Carlos

      //Compensaciones pérdidas año  2018 y anteriores - Cédula general
      //SI Cas 789 = 1 Y Cas 790 = 2 o 3 o 4; Cas 791

      let cas791T='0';
      if(this.model2100.doc.cuerpo.cc_id_789.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_789.length; i++) 
        {
          if( (Number(this.model2100.doc.cuerpo.cc_id_790[i].v)>=2 && Number(this.model2100.doc.cuerpo.cc_id_790[i].v)<5)
              && Number(this.model2100.doc.cuerpo.cc_id_789[i].v)===1)
          {
            cas791T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas791T, this.model2100.doc.cuerpo.cc_id_791[i].v);
          }
        }
      valor = cas791T;
      this.model2100.doc.cuerpo.cs_id_94 = valor;

      //Compensaciones por exceso de renta presuntiva - Cédula general
      //SI Cas 789 = 3Y Cas 790 = 2 o 3 o 4; Cas 791

      cas791T='0';
      if(this.model2100.doc.cuerpo.cc_id_790.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_790.length; i++) 
        {
          if( (Number(this.model2100.doc.cuerpo.cc_id_790[i].v)>1 && Number(this.model2100.doc.cuerpo.cc_id_790[i].v)<5)
              && Number(this.model2100.doc.cuerpo.cc_id_789[i].v)===3)
          {
            cas791T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas791T, this.model2100.doc.cuerpo.cc_id_791[i].v);
          }
        }
      valor = cas791T;
      this.model2100.doc.cuerpo.cs_id_95 = valor;
      
      //Rentas gravables - Cédula general
      //Cas 781

      valor = this.model2100.doc.cuerpo.cs_id_781;
      this.model2100.doc.cuerpo.cs_id_96 = valor;

      //98. Renta presuntiva - Cédula general
      //SI Cas 790 = 3 ; Cas 791
      
      valor='0';
      this.model2100.doc.cuerpo.cs_id_98 = valor;
      //Por dividendos y participaciones recibidas del exterior
      //SI Cas 492 = 4; Cas 493
      
      let cas493T='0';
      if(this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_492[i].v)===4)
          {
            cas493T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      valor = cas493T;
      this.model2100.doc.cuerpo.cs_id_120 = valor;

      //Impuestos pagados en el exterior - Liquidación privada - Descuentos
      //SI Cas 726 = 1; Cas 727   SI Cas 508 = 1 Y Cas 514 < 2021; Cas 521
      valor = '0';
      let cas727T='0';
      if(this.model2100.doc.cuerpo.cc_id_726.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_726.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_726[i].v)===1)
          {
            cas727T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas727T, this.model2100.doc.cuerpo.cc_id_727[i].v);
          }
        }

      let cas361T='0';
      if(this.model2100.doc.cuerpo.cc_id_361.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_361.length; i++) 
      {   
        cas361T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas361T, this.model2100.doc.cuerpo.cc_id_361[i].v);       
      }

      let cas521T='0';
      if(this.model2100.doc.cuerpo.cc_id_508.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_508.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_508[i].v)===2
          && Number(this.model2100.doc.cuerpo.cc_id_514[i].v) >= 2021)
        {
          cas521T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, this.model2100.doc.cuerpo.cc_id_521[i].v);
        }
      }

     
      valor =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, cas727T);
      valor =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas361T);
 
      this.model2100.doc.cuerpo.cs_id_122 = valor;

      //Donaciones - Liquidación privada - Descuentos
      //SI Cas 584 = 6 ; Cas 585
 
      cas727T='0';
      if(this.model2100.doc.cuerpo.cc_id_726.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_726.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_726[i].v)===3)
          {
            cas727T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas727T, this.model2100.doc.cuerpo.cc_id_727[i].v);
          }
        }
      valor = cas727T;
      this.model2100.doc.cuerpo.cs_id_123 = valor;
 
      //Dividendos, participaciones y otros 
      //SI Cas 492 = 4; Cas 493

      let cas493T2 = '0';
      let cas493T3 = '0';
      this.model2100.doc.cuerpo.cs_id_124 = "0";
      if (this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) {
          if (Number(this.model2100.doc.cuerpo.cc_id_492[i].v) === 2) {
            cas493T2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T2, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
          if (Number(this.model2100.doc.cuerpo.cc_id_492[i].v) === 3) {
            cas493T3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T3, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      cas493T3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas493T3, this.modelo.doc.cuerpo.cs_id_118);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T3, cas493T2);
      let valorDivEnUvt = this.convertirPesosUvt(valor);
      valorDivEnUvt = this.dutilidades.deshacerFormatoMoneda(valorDivEnUvt);
  
  
      if (Number(valorDivEnUvt) > 0 && Number(valorDivEnUvt) <= 1090) {
        valor = "0";
      } else if (Number(valorDivEnUvt) > 1090) {
        let valorUVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, String(valorDivEnUvt), "1090");
        valorUVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valorUVT, "0.19");
        valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valorUVT, this.UVT);
        valor = this.dutilidades.redondearValorMoneda(valor, true);
      }
      let cas727T4 = '0';
      if (this.model2100.doc.cuerpo.cc_id_726.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_726.length; i++) {
          if (Number(this.model2100.doc.cuerpo.cc_id_726[i].v) === 4) {
            cas727T4 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas727T4, this.model2100.doc.cuerpo.cc_id_727[i].v);
          }
        }
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas727T4);
      this.model2100.doc.cuerpo.cs_id_124 = valor;  
      
    ///Cas 127 
    
    const cas112 = this.dutilidades.redondearValorMoneda(this.model2100.doc.cuerpo.cs_id_112);
    const camposSuma= ['cs_id_113','cs_id_114'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.model2100, camposSuma, true);
    const resultadoCamposResta =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, resultadoCamposSuma, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta, "0")?"0":resultadoCamposResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.model2100.doc.cuerpo.cs_id_115 = valorRedondeado;

    let restaLoterias =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model2100.doc.cuerpo.cs_id_115, this.model2100.doc.cuerpo.cs_id_608, true);
    restaLoterias = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, restaLoterias, "0")?"0":restaLoterias;
    const restaLoteriaQuincePorCiento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, restaLoterias, '0.15', true);
    const loteriaVeintePorCiento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.model2100.doc.cuerpo.cs_id_608, '0.2', true);
    const suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, restaLoteriaQuincePorCiento, loteriaVeintePorCiento, true);

    this.model2100.doc.cuerpo.cs_id_127 = suma;
    //Descuento por impuestos pagados en el exterior por ganancias ocasionales - Liquidación privada
    //SI Cas 508 = 2 Y Cas 514 < 2021; Cas 521

    cas521T='0';
      if(this.model2100.doc.cuerpo.cc_id_508.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_508.length; i++) 
        {
          if( Number(this.model2100.doc.cuerpo.cc_id_508[i].v)===2
            && Number(this.model2100.doc.cuerpo.cc_id_514[i].v) < 2021)
          {
            cas521T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, this.model2100.doc.cuerpo.cc_id_521[i].v);
          }
        }
      valor = cas521T;
      this.model2100.doc.cuerpo.cs_id_128 = valor;

      //Anticipo renta liquidado año gravable anterior - Liquidación privada
      //Cas 810
      
      valor = this.model2100.doc.cuerpo.cs_id_795;
      this.model2100.doc.cuerpo.cs_id_130 = valor;

      //Saldo favor año grav. anterior sin solicitud de devolución y/o compensación - Liquidación privada
      //Cas 817
      
      
      valor = this.model2100.doc.cuerpo.cs_id_810
      this.model2100.doc.cuerpo.cs_id_131 = valor;

      //Retenciones año gravable.
      //Cas 334 + Cas 284 + Cas 310 + Cas 346 + Cas 362 + Cas 500 + Cas 521 + SI Cas 546 = 1; Cas 554+ Cas 615 + Cas 649 + 
      //Cas 594 + Cas 575 + Cas 364

      //334 compuesta
      let cas334T='0';
      if(this.model2100.doc.cuerpo.cc_id_334.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_334.length; i++) 
        {
          cas334T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas334T, this.model2100.doc.cuerpo.cc_id_334[i].v);
        }
      //284 compuesta
      let cas284T='0';
      if(this.model2100.doc.cuerpo.cc_id_284.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_284.length; i++) 
        {
          cas284T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas284T, this.model2100.doc.cuerpo.cc_id_284[i].v);
        }
      //310 compuesta
      let cas310T='0';
        if(this.model2100.doc.cuerpo.cc_id_310.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_310.length; i++) 
        {
          cas310T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas310T, this.model2100.doc.cuerpo.cc_id_310[i].v);
        }
      //346 compuesta
      let cas346T='0';
        if(this.model2100.doc.cuerpo.cc_id_346.length)
	      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_346.length; i++) 
	      {
	        cas346T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas346T, this.model2100.doc.cuerpo.cc_id_346[i].v);
	      }
      //362 compuesta
      let cas362T='0';
        if(this.model2100.doc.cuerpo.cc_id_362.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_362.length; i++) 
        {
          cas362T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas362T, this.model2100.doc.cuerpo.cc_id_362[i].v);
        }
      //500 compuesta
      let cas500T='0';
        if(this.model2100.doc.cuerpo.cc_id_500.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_500.length; i++) 
        {
          cas500T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas500T, this.model2100.doc.cuerpo.cc_id_500[i].v);
        }
      //521 compuesta
      cas521T='0';
		  if(this.model2100.doc.cuerpo.cc_id_521.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_521.length; i++) 
			{
			  cas521T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, this.model2100.doc.cuerpo.cc_id_521[i].v);
			}
      //554 compuesta
      //SI Cas 546 = 1; Cas 554
      let cas554T='0';
		  if(this.model2100.doc.cuerpo.cc_id_554.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_554.length; i++) 
			{
        if( Number(this.model2100.doc.cuerpo.cc_id_546[i].v)===1)
			    cas554T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas554T, this.model2100.doc.cuerpo.cc_id_554[i].v);
			}
      //615 compuesta
      let cas615T='0';
		  if(this.model2100.doc.cuerpo.cc_id_615.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_615.length; i++) 
			{
			  cas615T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas615T, this.model2100.doc.cuerpo.cc_id_615[i].v);
			}
      //649 compuesta
      let cas649T='0';
		  if(this.model2100.doc.cuerpo.cc_id_649.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_649.length; i++) 
			{
			  cas649T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas649T, this.model2100.doc.cuerpo.cc_id_649[i].v);
			}
      //594 compuesta
      let cas594T='0';
		  if(this.model2100.doc.cuerpo.cc_id_594.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_594.length; i++) 
			{
			  cas594T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas594T, this.model2100.doc.cuerpo.cc_id_594[i].v);
			}
      //575 compuesta
      let cas575T='0';
		  if(this.model2100.doc.cuerpo.cc_id_575.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_575.length; i++) 
			{
			  cas575T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas575T, this.model2100.doc.cuerpo.cc_id_575[i].v);
			}
      //364 compuesta
      let cas364T='0';
		  if(this.model2100.doc.cuerpo.cc_id_364.length)
			for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_364.length; i++) 
			{
			  cas364T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas364T, this.model2100.doc.cuerpo.cc_id_364[i].v);
			}
      valor= cas334T;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas284T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas310T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas346T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas362T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas500T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas521T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas554T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas615T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas649T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas594T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas575T, valor,true);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas364T, valor,true);
      this.model2100.doc.cuerpo.cs_id_132 = valor;

      //Anticipo renta para el año gravable siguiente - Liquidación privada
      //Cas 806
      let cas806T='0';
		 
      cas806T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas806T, this.model2100.doc.cuerpo.cs_id_806);
      valor = cas806T;
      this.model2100.doc.cuerpo.cs_id_133 = valor;

      //Sanciones - Liquidación privada
      //Cas 817

      valor = this.model2100.doc.cuerpo.cs_id_819;
      this.model2100.doc.cuerpo.cs_id_135 = valor;

      //Supera Tope Indicativo
      //Cas 745

      valor = this.model2100.doc.cuerpo.cc_id_745[0];
      this.model2100.doc.cuerpo.cs_id_140 = valor;

     
    //Val patrimonio líquido año anterior
    this.modelo.doc.cuerpo.cs_id_339 = this.model2100.doc.cuerpo.cs_id_812;

    //Gradualidad de la sanción
    this.modelo.doc.cuerpo.cs_id_340 = this.model2100.doc.cuerpo.cs_id_813;

  }

  agregarCasillaFueradeRango()
  {

    let datos = [];
    let valor = "";

     //Uno porciento factura electrónica
      //Cas Cas 653
      let cas653T='0';
      if(this.model2100.doc.cuerpo.cc_id_653.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_653.length; i++) 
        {
          cas653T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas653T, this.model2100.doc.cuerpo.cc_id_653[i].v);
        }
      valor = cas653T;
      //Se asigna directamente a la 297 del modelo 210 por repetición de casilla
      this.modelo.doc.cuerpo.cs_id_297 = valor;

    //Incluya solo el valor de la parte exenta de las cesantías retiradas
    //SI Cas 761 = 1 o 2 Y Cas 760 = 9; Cas 763
    let cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_761.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
          && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 9)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_246 = valor;
    
    //Valor ing por seguros o compensac por muerte de un miembro FFMM o de la Policía Nal?
    //SI Cas 760 = 8; Cas 763

    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 8)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_248 = valor;

    //Valor Ing exceso salario básico y prestaciones sociales como miembro de FFMM y de la Policía Nal?
    //SI Cas 760 = 7; Cas 763
    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 7)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_250 = valor;

    //Valor ing. gastos de representación como rector y/o profesor de Univ. públicas?
    //SI Cas 760 = 4; Cas 763

    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 4)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_252 = valor;

    //Valor Ing prima especial y costo de vida como diplomático consular y administrativo Min Rel ext?
    //SI Cas 760 = 5 o 6; Cas 763

    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 5)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_254 = valor;
    
    //Servicios hoteleros
    //SI Cas 760 = 10; Cas 763
    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 10
            && Number(this.model2100.doc.cuerpo.cc_id_761[i].v) === 4)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_256 = valor;

    //CAN Capital
    //Si Cas 761  = 3 Y Cas 761 = 11; Cas 763
    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===3 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 11)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_276 = valor;
    
    //CAN No laborales
    //Si Cas 761 = 4 Y Cas 761 = 11; Cas 763
    
    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===4)
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 11)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_278 = valor;
    //Valor ingreso magistrados de los tribunales sus fiscales y procuradores Judiciales
    //SI Cas 760 = 2 o 2 o 3; Cas 763

    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_760.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_760.length; i++) 
      {
        if( (Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 )
        && Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 1)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_280 = valor;

    //CAN Trabajo
    //Si Cas 761 = 1 o 2 Y Cas 761 = 11; Cas 763

    cas763T='0';
    if(this.model2100.doc.cuerpo.cc_id_761.length)
      for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_761.length; i++) 
      {
        if( Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===1 || Number(this.model2100.doc.cuerpo.cc_id_761[i].v)===2)
        {
        if(Number(this.model2100.doc.cuerpo.cc_id_760[i].v) === 11)
        {
          cas763T = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas763T, this.model2100.doc.cuerpo.cc_id_762[i].v);
        }
       }
      
      }
    valor = cas763T;
    this.modelo.doc.cuerpo.cs_id_281 = valor;

  /////////////////Casilla 355
  valor = this.model2100.doc.cuerpo.cs_id_280;
  this.modelo.doc.cuerpo.cs_id_355 = valor;

  }

  dependientres_2100()
  {
    /*242	N° Identificación 1	Cas 670 Item 1  SI Cas 280 > 0 adición al 10%
    241	Tipo de dependiente 1 	Cas 669 Item 1
    244	Parentesco 1	Cas 671 Item 1
    288	N° Identificación 2	Cas 670 Item 2
    287	Tipo de dependiente 2	Cas 669 Item 2
    289	Parentesco 2	Cas 671 Item 2
    291	N° Identificación 3	Cas 670 Item 3
    290	Tipo de dependiente 3 	Cas 669 Item 3
    292	Parentesco 3	Cas 671 Item 3
    294	N° Identificación 4	Cas 670 Item 4
    293	Tipo de dependiente 4 	Cas 669 Item 4
    295	Parentesco 4	Cas 671 Item 4*/
    //Dependiente 1
    this.modelo.doc.cuerpo.cs_id_242 = this.model2100.doc.cuerpo.cc_id_670[0]? this.model2100.doc.cuerpo.cc_id_670[0].v : '';
    if(this.modelo.doc.cuerpo.cs_id_242  && this.modelo.doc.cuerpo.cs_id_242 != '')this.modelo.doc.cuerpo.cs_id_335 = '1';
    this.modelo.doc.cuerpo.cs_id_241 = this.model2100.doc.cuerpo.cc_id_669[0]? this.model2100.doc.cuerpo.cc_id_669[0].v:'';
    this.modelo.doc.cuerpo.cs_id_244 = this.model2100.doc.cuerpo.cc_id_671[0]? this.model2100.doc.cuerpo.cc_id_671[0].v :'';

    //Dependiente 2
    this.modelo.doc.cuerpo.cs_id_288 = this.model2100.doc.cuerpo.cc_id_670[1]? this.model2100.doc.cuerpo.cc_id_670[1].v:'';
    this.modelo.doc.cuerpo.cs_id_287 = this.model2100.doc.cuerpo.cc_id_669[1]? this.model2100.doc.cuerpo.cc_id_669[1].v:'';
    this.modelo.doc.cuerpo.cs_id_289 = this.model2100.doc.cuerpo.cc_id_671[1]? this.model2100.doc.cuerpo.cc_id_671[1].v:'';

    //Dependiente 3
    this.modelo.doc.cuerpo.cs_id_291 = this.model2100.doc.cuerpo.cc_id_670[2] ? this.model2100.doc.cuerpo.cc_id_670[2].v:'';
    this.modelo.doc.cuerpo.cs_id_290 = this.model2100.doc.cuerpo.cc_id_669[2] ? this.model2100.doc.cuerpo.cc_id_669[2].v:'';
    this.modelo.doc.cuerpo.cs_id_292 = this.model2100.doc.cuerpo.cc_id_671[2] ? this.model2100.doc.cuerpo.cc_id_671[2].v:'';

     //Dependiente 4
     this.modelo.doc.cuerpo.cs_id_294 = this.model2100.doc.cuerpo.cc_id_670[3] ? this.model2100.doc.cuerpo.cc_id_670[3].v:'';
     this.modelo.doc.cuerpo.cs_id_293 = this.model2100.doc.cuerpo.cc_id_669[3] ? this.model2100.doc.cuerpo.cc_id_669[3].v:'';
     this.modelo.doc.cuerpo.cs_id_295 = this.model2100.doc.cuerpo.cc_id_671[3] ? this.model2100.doc.cuerpo.cc_id_671[3].v:'';

     

  }
  dividendos_2100()
  {
    /*
    304	Tarifa 1 2a Subcedula	Cas 499 Item 1
    305	Base 1 2a subcedula	Cas 493 Item 1
    307	Tarifa 2 2a Subcedula	Cas 499 Item 2
    308	Base 2 2a subcedula	Cas 493 Item 2
    310	Tarifa 3 2a Subcedula	Cas 499 Item 3
    311	Base 3 2a subcedula	Cas 493 Item 3
    313	Tarifa 4 2a Subcedula	Cas 499 Item 4
    314	Base 4 2a subcedula	Cas 493 Item 4
    319	Tarifa 5 2a Subcedula	Cas 499 Item 5
    318	Base 5 2a subcedula	Cas 493 Item 5
    320	Tarifa 6 2a Subcedula	Cas 499 Item 6
    321	Base 6 2a subcedula	Cas 493 Item 6
    323	Tarifa 7 2a Subcedula	Cas 499 Item 7
    324	Base 7 2a subcedula	Cas 493 Item 7
    326	Tarifa 8 2a Subcedula	Cas 499 Item 8
    327	Base 8 2a subcedula	Cas 493 Item 8
    329	Tarifa 9 2a Subcedula	Cas 499 Item 9
    330	Base 9 2a subcedula	Cas 493 Item 9
    332	Tarifa 10 2a Subcedula	Cas 499 Item 10
    333	Base 10 2a subcedula	Cas 493 Item 10
 */
    //Dividendos
    
    this.modelo.doc.cuerpo.cs_id_306 ='';
    this.modelo.doc.cuerpo.cs_id_309 ='';
    this.modelo.doc.cuerpo.cs_id_312 ='';
    this.modelo.doc.cuerpo.cs_id_315 ='';
    this.modelo.doc.cuerpo.cs_id_317 ='';
    this.modelo.doc.cuerpo.cs_id_320 ='';
    this.modelo.doc.cuerpo.cs_id_323 ='';
    this.modelo.doc.cuerpo.cs_id_326 ='';
    this.modelo.doc.cuerpo.cs_id_329 ='';
    this.modelo.doc.cuerpo.cs_id_332 ='';


  
    let array492_3 = [];
    if(this.model2100.doc.cuerpo.cc_id_492.length){
      for (let i=0;i<this.model2100.doc.cuerpo.cc_id_492.length;i++){
        if(Number(this.model2100.doc.cuerpo.cc_id_492[i].v) === 3)
          array492_3.push(i);
          
      }
    }

    if(array492_3.length>0){
      for(let j=0;j<array492_3.length;j++){
      let j492 = array492_3[j];
        if(j==0){
          this.modelo.doc.cuerpo.cs_id_304 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_305 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 1){
          this.modelo.doc.cuerpo.cs_id_307 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_308 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 2){
          this.modelo.doc.cuerpo.cs_id_310 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_311 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 3){
          this.modelo.doc.cuerpo.cs_id_313 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_314 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 4){
          this.modelo.doc.cuerpo.cs_id_319 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_318 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 5){
          this.modelo.doc.cuerpo.cs_id_320 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_321 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 6){
          this.modelo.doc.cuerpo.cs_id_323 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_324 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 7){
          this.modelo.doc.cuerpo.cs_id_326 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_327 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 8){
          this.modelo.doc.cuerpo.cs_id_329 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_330 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }else if(j == 9){
          this.modelo.doc.cuerpo.cs_id_332 = this.model2100.doc.cuerpo.cc_id_499[j492].v ? this.model2100.doc.cuerpo.cc_id_499[j492].v : '';
          this.modelo.doc.cuerpo.cs_id_333 = this.model2100.doc.cuerpo.cc_id_493[j492].v ? this.model2100.doc.cuerpo.cc_id_493[j492].v : '';
        }
      }  
    }

    if(this.modelo.doc.cuerpo.cs_id_305 !='0')this.operacionDividendos('cs_id_304', 'cs_id_305', 'cs_id_306',false);
    if(this.modelo.doc.cuerpo.cs_id_308 !='0')this.operacionDividendos('cs_id_307', 'cs_id_308', 'cs_id_309',false);
    if(this.modelo.doc.cuerpo.cs_id_311 !='0')this.operacionDividendos('cs_id_310', 'cs_id_311', 'cs_id_312',false);
    if(this.modelo.doc.cuerpo.cs_id_314 !='0')this.operacionDividendos('cs_id_313', 'cs_id_314', 'cs_id_315',false);
    if(this.modelo.doc.cuerpo.cs_id_318 !='0')this.operacionDividendos('cs_id_319', 'cs_id_318', 'cs_id_317',false);
    if(this.modelo.doc.cuerpo.cs_id_321 !='0')this.operacionDividendos('cs_id_322', 'cs_id_321', 'cs_id_320',false);
    if(this.modelo.doc.cuerpo.cs_id_324 !='0')this.operacionDividendos('cs_id_325', 'cs_id_324', 'cs_id_323',false);
    if(this.modelo.doc.cuerpo.cs_id_327 !='0')this.operacionDividendos('cs_id_328', 'cs_id_327', 'cs_id_326',false);
    if(this.modelo.doc.cuerpo.cs_id_330 !='0')this.operacionDividendos('cs_id_331', 'cs_id_330', 'cs_id_329',false);
    if(this.modelo.doc.cuerpo.cs_id_333 !='0')this.operacionDividendos('cs_id_334', 'cs_id_333', 'cs_id_332',false);

   
    
  }
   //Verificar operación por corrimiento de casillas
  //CASILLAS QUE SE CALCULAN EN EL RECALCULO DEL 210

  //Anticipo renta para el año gravable siguiente - Liquidación privada
  operacionCs133() {

    let valor = "";
    /////////////////////Verificar la operación con funcionales, la casilla 133 no existe en versión 18
    const cas127 = this.modelo.doc.cuerpo.cs_id_126;
    const cas133 = this.modelo.doc.cuerpo.cs_id_133;
    //fix inicializacion casilla 385 casos anteriores que venían en valor 0
    this.model2100.doc.cuerpo.cs_id_385=(this.model2100.doc.cuerpo.cs_id_385 == undefined ||this.model2100.doc.cuerpo.cs_id_385=="0" ) ?"1":this.model2100.doc.cuerpo.cs_id_385;
    const cas385 = this.model2100.doc.cuerpo.cs_id_385;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas385, "1")) {
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.25");
      valor = this.dutilidades.redondearValorMoneda(valor, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
        this.modelo.doc.cuerpo.cs_id_134 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
      } else {
        this.modelo.doc.cuerpo.cs_id_134 = "0";
      }
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas385, "2")) {

      //Calculo anticipo 50% - impuesto actual
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.5");
      valor = this.dutilidades.redondearValorMoneda(valor, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
        this.model2100.doc.cuerpo.cs_id_389 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
      } else {
        this.model2100.doc.cuerpo.cs_id_389 = "0";
      }

      //Calculo anticipo 50% - impuesto promedio
      let cas386 = this.model2100.doc.cuerpo.cs_id_386;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas386, cas127);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.25");
      valor = this.dutilidades.redondearValorMoneda(valor, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
        this.model2100.doc.cuerpo.cs_id_390 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
      } else {
        this.model2100.doc.cuerpo.cs_id_390 = "0";
      }

      const cas389 = this.model2100.doc.cuerpo.cs_id_389;
      const cas390 = this.model2100.doc.cuerpo.cs_id_390;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas389, cas390)) {
        this.model2100.doc.cuerpo.cs_id_430 = cas389;
      } else {
        this.model2100.doc.cuerpo.cs_id_430 = cas390;
      }
      this.modelo.doc.cuerpo.cs_id_134 = this.model2100.doc.cuerpo.cs_id_430;

    } else {

      //Calculo anticipo 75% - impuesto actual
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.75");
      valor = this.dutilidades.redondearValorMoneda(valor, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
        this.model2100.doc.cuerpo.cs_id_391 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
      } else {
        this.model2100.doc.cuerpo.cs_id_391 = "0";
      }

      //Calculo anticipo 75% - impuesto promedio
      let cas386 = this.model2100.doc.cuerpo.cs_id_386;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas386, cas127);
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.375");
      valor = this.dutilidades.redondearValorMoneda(valor, true);
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
        this.model2100.doc.cuerpo.cs_id_392 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
      } else {
        this.model2100.doc.cuerpo.cs_id_392 = "0";
      }

      const cas391 = this.model2100.doc.cuerpo.cs_id_391;
      const cas392 = this.model2100.doc.cuerpo.cs_id_392;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas391, cas392)) {
        this.model2100.doc.cuerpo.cs_id_430 = cas391;
      } else {
        this.model2100.doc.cuerpo.cs_id_430 = cas392;
      }
      this.modelo.doc.cuerpo.cs_id_134 = this.model2100.doc.cuerpo.cs_id_430;

    }
    this.model2100.doc.cuerpo.cs_id_134 = this.modelo.doc.cuerpo.cs_id_134;

    this.operacionCs134();
  }

  // Diligenciar las casillas formuladas del 210 en el 2100
  casillasFormuladas2100() {

    this.model2100.doc.cuerpo.cs_id_31 = this.modelo.doc.cuerpo.cs_id_31;

  }

  recalculoCasilla124(){
    let valor = "0";
    let cas493T2 = '0';
      let cas493T3 = '0';
      this.model2100.doc.cuerpo.cs_id_124 = "0";
      if (this.model2100.doc.cuerpo.cc_id_492.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_492.length; i++) {
          if (Number(this.model2100.doc.cuerpo.cc_id_492[i].v) === 2) {
            cas493T2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T2, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
          if (Number(this.model2100.doc.cuerpo.cc_id_492[i].v) === 3) {
            cas493T3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T3, this.model2100.doc.cuerpo.cc_id_493[i].v);
          }
        }
      cas493T3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas493T3, this.modelo.doc.cuerpo.cs_id_118);
      cas493T3=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas493T3, '0')?'0':cas493T3;
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas493T3, cas493T2);
      let valorDivEnUvt = this.convertirPesosUvt(valor);
      valorDivEnUvt = this.dutilidades.deshacerFormatoMoneda(valorDivEnUvt);
  
  
      if (Number(valorDivEnUvt) > 0 && Number(valorDivEnUvt) <= 1090) {
        valor = "0";
      } else if (Number(valorDivEnUvt) > 1090) {
        let valorUVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, String(valorDivEnUvt), "1090");
        valorUVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valorUVT, "0.19");
        valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valorUVT, this.UVT);
        valor = this.dutilidades.redondearValorMoneda(valor, true);
      }
      let cas727T4 = '0';
      if (this.model2100.doc.cuerpo.cc_id_726.length)
        for (let i = 0; i < this.model2100.doc.cuerpo.cc_id_726.length; i++) {
          if (Number(this.model2100.doc.cuerpo.cc_id_726[i].v) === 4) {
            cas727T4 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas727T4, this.model2100.doc.cuerpo.cc_id_727[i].v);
          }
        }
      valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, valor, cas727T4);
      this.modelo.doc.cuerpo.cs_id_124 = valor;  

  }


  //FIN OPERACIONES 2100 H1

  private initializeModel2100() {
    const config = DFormulario2100Configuracion.CONFIGURACION_CASILLAS_2100;
    const configCompuestas = DFormulario2100Configuracion.CONFIGURACION_CASILLAS_COMPUESTAS_RANGOS_2100;
    const serviceInitialize = new InitializeModelService(config, configCompuestas);
    this.model2100 = serviceInitialize.initializeModel(this.model2100);
  }

  cargarModel2100() {
    let ideDocumento = (Number(this.modelo.doc.cab.cs_id_4));
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioRESTAPI.obtenerDilAnexo(ideDocumento)
      .subscribe(
        (res: any) => {
          if (!res) {
            console.log("El servicio responde OK pero no se obtienen datos");
            this.initializeModel2100();
            precargaProceso.close();
            return;
          }

          let resEncoded: string = res.valJson;
          let jsonDecoded: string = atob(resEncoded);
          this.model2100.doc =JSON.parse(jsonDecoded);
          this._messagesObs.sendMessages('model2100Completed', this.model2100);
          this.validateAllSectionsIsCompleted();
          //fix inicialización casilla 385
          this.model2100.doc.cuerpo.cs_id_385=(this.model2100.doc.cuerpo.cs_id_385 == undefined ||this.model2100.doc.cuerpo.cs_id_385=="0" ) ?"1":this.model2100.doc.cuerpo.cs_id_385;
             
          this.initializeModel2100();
          precargaProceso.close();
          this.infoCargada = true;
        }, error => {
          //No se encontró por cas4: Validar si formulario corrige otro: si cas26
          console.log("Servicio cargar model 2100 ejecutado con error. 1 " + error.mensaje);
          if(this.modelo.doc.cuerpo.cs_id_26!=undefined && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelo.doc.cuerpo.cs_id_26, "0")){
            ideDocumento = (Number(this.modelo.doc.cuerpo.cs_id_26));
            this.dServicioRESTAPI.obtenerDilAnexo(ideDocumento)
              .subscribe(
                (res: any) => {
                  if (!res) {
                    console.log("El servicio responde OK pero no se obtienen datos");
                    this.initializeModel2100();
                    precargaProceso.close();
                    return;
                  }

                  let resEncoded: string = res.valJson;
                  let jsonDecoded: string = atob(resEncoded);
                  this.model2100.doc = JSON.parse(jsonDecoded);
                  this.model2100.doc.cab.cs_id_4 = this.modelo.doc.cab.cs_id_4;
                  this._messagesObs.sendMessages('model2100Completed', this.model2100);
                  this.validateAllSectionsIsCompleted();
                  precargaProceso.close();
                  this.infoCargada = true;

                }, error => {
                  console.log("Servicio cargar model 2100 ejecutado con error. 2 " + error.mensaje);
                  this.initializeModel2100();
                  precargaProceso.close();
                  this.infoCargada = true;
                }
              );
          }else{
            console.log("Servicio cargar model 2100 ejecutado con error. 3 " + error.mensaje);
            this.initializeModel2100();
            this.validacionDatos210();
            precargaProceso.close();
            this.infoCargada = true;
          }
        }
      );
  }

  saveModel2100(boolsalvar:boolean = true) {
    console.log("saveModel2100 en formulario-no-experto.components!!!" + this.modelo.doc.cab.cs_id_4);
    if(boolsalvar)
      this.boolAnticipos=false;
    let encode: string = btoa(this.setJSONBody(this.model2100.doc));
    let nit: string = this.modelo.doc.cab.cs_id_5;
    let dilAnexo: any = {};
    if (this.modelo.doc.cab.cs_id_4 != undefined && this.modelo.doc.cab.cs_id_4 != null && Number(this.modelo.doc.cab.cs_id_4) >= 0) {
      dilAnexo.ideDocumento = Number(this.modelo.doc.cab.cs_id_4);
      dilAnexo.valJson = encode;
      dilAnexo.fecCambio = null;
      dilAnexo.status = null;
      dilAnexo.statusText = null;
      this.crearActualizarDilAnexo(nit, dilAnexo);
    }
  }
  activarGuardado(activaGuardado:boolean=false)
  {
    this.boolAnticipos=activaGuardado;
  }
  verificarCasillasIngreso()
  {
   if(  this.model2100.doc.cuerpo.cs_id_276==='0'
        && this.model2100.doc.cuerpo.cs_id_301==='0'
        && this.model2100.doc.cuerpo.cs_id_323==='0'
        && this.model2100.doc.cuerpo.cs_id_338==='0'
        && this.model2100.doc.cuerpo.cs_id_350==='0'
        && this.model2100.doc.cuerpo.cs_id_367==='0'
        && this.model2100.doc.cuerpo.cs_id_381==='0'
        && this.model2100.doc.cuerpo.cs_id_507==='0'
        && this.model2100.doc.cuerpo.cs_id_534==='0'
        && this.model2100.doc.cuerpo.cs_id_564==='0'
        && this.model2100.doc.cuerpo.cs_id_581==='0'
        && this.model2100.doc.cuerpo.cs_id_604==='0'
        && this.model2100.doc.cuerpo.cs_id_621==='0'
        && this.model2100.doc.cuerpo.cs_id_635==='0' )this.boolAnticipos=true;
  }

  public setJSONBody(body: any) {
    let JSONbody
    if (body instanceof String) {
      JSONbody = body.toString();
    } else if (typeof body === "string") {
      JSONbody = body;
    } else {
      JSONbody = JSON.stringify(body);
    }
    return JSONbody;
  }

  private crearActualizarDilAnexo(nit: string, dilAnexo: any) {
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioRESTAPI.crearActualizarDilAnexo(nit, dilAnexo)
      .subscribe(
        res => {
          console.log("Servicio crearActualizarDilAnexo ejecutado correctamente");
          precargaProceso.close();
        }, error => {
          console.error("Servicio cargar model 2100 ejecutado con error" + error);
          precargaProceso.close();
        }
      );
  }

  validacionDatos210(){
    const cas337 = this.modelo.doc.cuerpo.cs_id_337;
    if(cas337=="1"){//Es una sugerida
      //patrimonio liquido año anterior
      const cas339 = this.modelo.doc.cuerpo.cs_id_339;
      //gradualidad de la sanción
      const cas340 = this.modelo.doc.cuerpo.cs_id_340;

      if(cas340 != undefined && (cas340=="1" || cas340=="2" || cas340=="3" || cas340=="4")){
        this.model2100.doc.cuerpo.cs_id_811 = "1";
        this.model2100.doc.cuerpo.cs_id_812 = cas339;
        this.model2100.doc.cuerpo.cs_id_813 = cas340;
      }
    }
  }

  redirectIngreso(): void {
    window.location.href = window.location.origin + '/' + environment.urlIngreso + '/#/ingreso';
  }

  private getAnio(): number {
    const anioDeclaracion = (this.modelo.doc.cuerpo.cs_id_27 &&
      (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true")) ?
      Number(this.anioDeclaracion) + 1 : this.anioDeclaracion;
    return Number(anioDeclaracion);
  }

  private calcularTarifasAB() {
    const anio2020 = this.modelo.doc.cab.cs_id_1 == "2020";
    const anio2021 = this.modelo.doc.cab.cs_id_1 == "2021";
    const anio2022 = this.modelo.doc.cab.cs_id_1 == "2022";
    const anio2023 = this.modelo.doc.cab.cs_id_1 == "2023";
    const anio2024 = this.modelo.doc.cab.cs_id_1 == "2024";
    const fraccion = this.modelo.doc.cuerpo.cs_id_27 && (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true")
    if (anio2020 && !fraccion) {
      this.tarifaA = "0.32";
      this.tarifaB = "0.68";
    } else if (anio2020 && fraccion) {
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    } else if (anio2021 && !fraccion) {
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    } else if (anio2021 && fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2022 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2022 && fraccion) {
      this.tarifaA = "0.35";
    } else if (anio2023 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2023 && fraccion) {
      this.tarifaA = "0.35";
    } else if (anio2024 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2024 && fraccion) {
      this.tarifaA = "0.35";
    } else if(this.getAnio()>=2023 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (this.getAnio()>=2023 && fraccion) {
      this.tarifaA = "0.35";
    }
    
    
 }

  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;
    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if ((i + 1) < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i + 1].desde);
      } else {
        hasta = true;
      }
      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        const punto = resultadoMultiplicacion.indexOf(".");
        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0, punto + 3);
        }
        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        const resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;
      }
    }
    return "0";
  }

  private aplicarTablaCasilla121(baseGravable, rangos) {
    let desde: boolean = false;
    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if ((i + 1) < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i + 1].desde);
      } else hasta = true;

      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        const punto = resultadoMultiplicacion.indexOf(".");
        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0, punto + 3);
        }
        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        const resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;
      }
    }

    return "0";
  }
  //Fin Helpers

  //Funciones controladoras de componentes de tabs y stepper del formulario  
  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      /*if (res.operation === 'open-decla-sug')
        this.showSecondModalHelpDeclaracionSugerida(true);*/

      if (res.operation === 'save-form') {
        this.procesarSinNotificaciones = false;
        this.saveModel2100(false);
        this.validarPreguntas();
      }

      if (res.operation === 'change-tab') {
        this.onSelectTab(res.message);
      }

      if (res.operation === 'back-form') {
        this.indexSelectedTab = 1;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
      }

      if (res.operation === 'calcular126') {
        this.renderizarFormulario(126);
      }

      if (res.operation === 'calcular129') {
        this.renderizarFormulario(129);
      }
    });
  }

  changeTab(add: boolean = true): void {
    this.validateAllSectionsIsCompleted();

    if (!add) {
      this.indexSelectedTab--;
      this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
      return;
    }

    if (this.indexSelectedTab === 0) {
      this.verificaDisponiblidad();
    }
    if (add && this.indexSelectedTab === 1) {
      this.verificaDisponiblidad();
      if(this.disponibilidad)
      {
        this.saveModel2100(false);
        this.guardarYRenderizarFormulario();
      }
      return;
    }

    if (this.firmaRequerida) this.flowTabsConFirma(add);
    else this.flowTabsSinFirma(add);
  }

  onSelectTab(model: SelectTabOption) {
    if (!model.item.clickable) return;

    this.validateAllSectionsIsCompleted();

    if (model.index >= 1 &&
      (this.firmaRequerida && !this.atributosDocumento.docAtributos.esPresentado) ||
      (!this.firmaRequerida && !this.atributosDocumento.docAtributos.esDefinitivo)
    ) {
      if (this.indexSelectedTab == 0 && !this.preguntasContestadas) {
        this._notifications.showError('Por favor conteste las preguntas iniciales.');
        return;
      }
    }

    if (model.index === 1) {
      let showError = false;

      if (this.firmaRequerida) {
        if (!this.atributosDocumento.docAtributos.esPresentado) {
          this.indexSelectedTab = 1;
          this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        } else {
          if (model.index > this.indexSelectedTab) {
            this.indexSelectedTab = model.index;
            this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
          } else showError = true;
        }
      } else {
        if (!this.atributosDocumento.docAtributos.esDefinitivo) {
          this.indexSelectedTab = 1;
          this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        } else {
          if (model.index > this.indexSelectedTab) {
            this.indexSelectedTab = model.index;
            this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
          } else showError = true;
        }
      }

      if (showError) {
        const estado = this.firmaRequerida ? 'presentado' : 'definitivo';
        this._notifications.showInfo(`El documento se encuentra en estado ${estado} no es posible editarlo.`);
      }

      return;
    }

    if (model.index === 2) {
      //this.loadingResume = true;
      this.verificaDisponiblidad();
      if(this.disponibilidad)
      {
        this.saveModel2100(false);
        this.guardarYRenderizarFormulario();
      }
      //this.loadingResume = false;
      return;
    }
  }
//calcula el formulario para obtener casilla 126
  private renderizarFormulario(id: number) {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga('Cargando');
    const obs = new Observable(observer => {
      try {
        setTimeout(() => {
          this.modelo.doc.cuerpo.cs_id_337 = '0';
          this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto    
          this.llenarHoja1_2100();
          this.copyModel();
          console.log("ini operaciones");
          this.recalcularFormulario(); 
          console.log("fin operaciones");
          observer.next();  
          observer.complete(); 
        }, 2000);         
      } catch (e) {
        observer.error(e);
      }
    });  
    
    obs.subscribe(
      res => {
        preloader.close();
        if (id === 126)
          this._messagesObs.sendMessages('calculado126', true);
        if (id === 129)
          this._messagesObs.sendMessages('calculado129', true);
      },
      error => preloader.close(),
      () => preloader.close()
    );
  } 

  private guardarYRenderizarFormulario() {
    if(!this.boolAnticipos)
    {
      ///////////////////Se modifica para 2024 se optimiza asalariado y se deshabilita operación
      this.boolAnticipos=true;
      //this.verificarCasillasIngreso();
    }
    if(this.boolAnticipos)
    {
        let id =126;
        this.modelo.doc.cuerpo.cs_id_337 = '0';
        this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto    
        if (!this.atributosDocumento.docAtributos.enProcesoFirmas && !this.atributosDocumento.docAtributos.esPresentado) {
          const preloader = this.dNotificacionServicio.mostrarDialogoCarga('Cargando');
          const obs = new Observable(observer => {
            try {
              setTimeout(() => {
                this.modelo.doc.cuerpo.cs_id_337 = '0';
                this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto    
                this.llenarHoja1_2100();
                this.copyModel();
                console.log("ini operaciones");
                this.recalcularFormulario(); 
                console.log("fin operaciones");
                this.guardarActualizarBorrador(true);
                observer.next();  
                observer.complete(); 
              }, 2000);         
            } catch (e) {
              observer.error(e);
            }
          });  
          
          obs.subscribe(
            res => {
              preloader.close();
              if (id === 126)
                this._messagesObs.sendMessages('calculado126', true);
              if (id === 129)
                this._messagesObs.sendMessages('calculado129', true);
            },
            error => preloader.close(),
            () => preloader.close()
          );
      
        } else {
          this.imprimirFormulario(true);
        }
    
       this.indexSelectedTab = 2;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
    }
    else
    {
      this._notifications.showInfo(`Antes de continuar, vaya a la sección <b>\"Impuesto de renta\"</b> y consulte si debe pagar anticipo de renta.`);
    }
  }

  validarExtemporaneidad() {
    if (this.indexSelectedTab == 2) {
      this.changeTab(true);
      return;
    }

    if (!this.validar2100()) {
      this.indexSelectedTab = 1;
      this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
      return;
    }
    else this.changeTab(true);    
  }

  private validar2100(): boolean {
    const valor1 = this.model2100.doc.cuerpo.cs_id_372;
    const valor2 = this.model2100.doc.cuerpo.cs_id_680;
    if (!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,valor1,valor2)) {
      this.dNotificacionServicio.mostrarDialogoInformacion("Los valores registrados no suman el valor total de la herencia o porción conyugal reportado");
      return false;
    }
    if(this.extemporaneidad.esExtemporaneo){
      const title = 'Está presentando su declaración fuera del plazo establecido.';
      const message = 'Regrese al <b>formulario 210</b> y vaya a la sección <b>"Descuentos tributarios y otros"</b>. Allí, responda a la pregunta: <b>"¿Desea registrar una sanción por extemporaneidad?"</b>';      
      //let msg = "Usted es extemporáneo, debe diligenciar en la sección de descuentos otros, los datos de sanción por extemporaneidad";
      if(this.model2100.doc.cuerpo.cs_id_811 == null || this.model2100.doc.cuerpo.cs_id_811 == "0"){
        //this.dNotificacionServicio.mostrarDialogoInformacion(msg);
        this.dNotificacionServicio.mostrarDialogoInfoBasic(title, message); 
        return false;
      }
      if(this.model2100.doc.cuerpo.cs_id_811 == "1" && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, this.model2100.doc.cuerpo.cs_id_813, "0")){
        //this.dNotificacionServicio.mostrarDialogoInformacion(msg);
        this.dNotificacionServicio.mostrarDialogoInfoBasic(title, message); 
        return false;
      }
    }

    return true;     
  }

  flowTabsConFirma(add: boolean = true) {
    if (!add && this.atributosDocumento.docAtributos.enProcesoFirmas) {
      this.dialog.open(GeneralDialogComponent, {
        disableClose: true,
        data: DialogsConfig.dialogoConfigDesautorizarFirma
      }).afterClosed().subscribe(res => {
        if (!res) return;
        this.validarRespuestaCambioTab = true;
        this.validarCambioFirma();
      });
      return;
    }

    //Mostrar firmar
    if (add && this.indexSelectedTab === 2 && !this.mostrarFirmaBtn) {
      this._notifications.showInfo('Para firmar su declaración, es importante que el documento se encuentre en estado "Borrador".');
      return;
    }

    //Mostrar presentar
    if (add && this.indexSelectedTab === 3 && !this.mostrarPresentarBtn) {
      this._notifications.showInfo("Primero firme el documento para presentarlo.");
      return;
    }

    //Mostrar pagar
    if (add && this.indexSelectedTab === 4 && !this.mostrarPagarBtn) {
      this._notifications.showInfo('Para realizar el pago de su declaración, es importante que el documento se encuentre en estado "Presentado".');
      return;
    }

    if (
      this.atributosDocumento.docAtributos.esPresentado &&
      (
        !this.liquidacionRecigoPago ||
        !this.liquidacionRecigoPago.ideDocumento
      )
    ) {
      this.liquidarPagarFormulario();
      return;
    }

    //Logica normal del componente de tabs
    if (add) {
      /*if (this.indexSelectedTab == 0 && !this.atributosDocumento.docAtributos.esPresentado)
        this.validateGetSugerida();*/

      if (this.indexSelectedTab == 1)
        this.validarPreguntas();

      this.indexSelectedTab++;
    } else this.indexSelectedTab--;
    this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
    this._messagesObs.sendMessages('index-tab-stepper', {
      tab: this.indexSelectedTab,
      stepper: this.indexStepper
    });
  }

  private flowTabsSinFirma(add: boolean = true) {
    //Mostrar firmar
    if (this.indexSelectedTab === 2) {
      this.dialog.open(GeneralDialogComponent, {
        disableClose: true,
        data: DialogsConfig.dialogoConfigSinFirma
      }).afterClosed().subscribe(res => {
        if (!res) return;
        window.location.href = window.location.origin + '/WebDashboard/DefDashboard.faces';
      });
    }

    if (
      this.atributosDocumento.docAtributos.esDefinitivo &&
      (
        !this.liquidacionRecigoPago ||
        !this.liquidacionRecigoPago.ideDocumento
      )
    ) {
      this.liquidarPagarFormulario();
      return;
    }

    //Logica normal del componente de tabs
    if (add) {
      /*if (this.indexSelectedTab == 1 && !this.atributosDocumento.docAtributos.esDefinitivo)
        this.validateGetSugerida();*/

      if (this.indexSelectedTab == 2)
        this.validarPreguntas();

      this.indexSelectedTab++;
    } else this.indexSelectedTab--;
    this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
    this._messagesObs.sendMessages('index-tab-stepper', {
      tab: this.indexSelectedTab,
      stepper: this.indexStepper
    });
  }

 /* private validateGetSugerida(): void {
    if (
      this.anioDeclaracion >= 2020 &&
      this.dDatosCompartidosCabecera.concepto === 'inicial'
    ) //this.obtenerDeclaracionSugerida();
    this;
  }*/

  validateQuestions(step: number) {
    switch (step) {
      case 1:
        if (this.tiempoPermanencia && this.tiempoPermanencia == '1') this.showEsResidente(true);
        break;
      case 2:
        if (this.completoPeriodoPermanencia && this.completoPeriodoPermanencia == '1') this.showEsResidente(true);
        break;
      case 3:
        if (this.tieneNacionalidadColombiana && this.tieneNacionalidadColombiana == '0') this.showEsResidente(false);
        break;
      case 4:
        if (this.servicioEstadoEnExterior && this.servicioEstadoEnExterior == '1') this.showEsResidente(true);
        break;
      case 5:
        if (this.ingresosJurisdiccionDomicilio === '1' || this.activosJurisdiccionExterior === '1')
          this.showEsResidente(false);
        else {
          if (
            (this.ingresosJurisdiccionDomicilio && this.ingresosJurisdiccionDomicilio === '0') &&
            (this.activosJurisdiccionExterior && this.activosJurisdiccionExterior === '0') &&
            (this.esFamiliaResidenteFiscal && this.esFamiliaResidenteFiscal === '1') ||
            (this.ingresosFuenteNacional && this.ingresosFuenteNacional === '1') ||
            (this.bienesAdministradosColombia && this.bienesAdministradosColombia === '1') ||
            (this.activosPoseidosColombia && this.activosPoseidosColombia === '1') ||
            (this.esResidenteParaisoFiscal && this.esResidenteParaisoFiscal === '1') ||
            (this.noPuedeAcreditarResidenteExterior && this.noPuedeAcreditarResidenteExterior === '0')
          ) this.showEsResidente(true);

          if (
            (this.ingresosJurisdiccionDomicilio && this.ingresosJurisdiccionDomicilio === '0') &&
            (this.activosJurisdiccionExterior && this.activosJurisdiccionExterior === '0') &&
            (this.esFamiliaResidenteFiscal && this.esFamiliaResidenteFiscal === '0') &&
            (this.ingresosFuenteNacional && this.ingresosFuenteNacional === '0') &&
            (this.bienesAdministradosColombia && this.bienesAdministradosColombia === '0') &&
            (this.activosPoseidosColombia && this.activosPoseidosColombia === '0') &&
            (this.esResidenteParaisoFiscal && this.esResidenteParaisoFiscal === '0') &&
            (this.noPuedeAcreditarResidenteExterior && this.noPuedeAcreditarResidenteExterior === '1')
          ) this.showEsResidente(false);
        }
        break;
    }
  }

  private showEsResidente(value: boolean) {
    this.preguntasContestadas = true;
    this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: value ? DialogsConfig.dialogoConfigEsResidente : DialogsConfig.dialogoConfigNoEsResidente
    }).afterClosed().subscribe(res => {
      if (res === '') return;
      if (!value && res) window.location.href = this.ruta110;
      if (value && res) this.changeTab(true);
    });
  }

  private validateStateForm(changeSection: boolean = false): void {
    if (!this.firmaRequerida) {
      if (this.atributosDocumento.docAtributos.esDefinitivo) {
        this.dDatosCompartidosCabecera.estado = 'Definitivo';
        this._messagesObs.sendMessages('info-form', this.dDatosCompartidosCabecera);
      }
    }
   
  }
  //Fin Funciones controladoras de componentes de tabs y stepper del formulario

  
  /* private obtenerDeclaracionSugerida() {
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioRESTAPI.obtenerDeclaracionSugerida(this.modelo.doc.cab.cs_id_5, this.anioDeclaracion).subscribe(
      (res: any) => {
        if (!res || !res.length) return;
        //this._messagesObs.sendMessages('show-declasug', true);

        let alertaFactura = true;
        this.declaracionSugerida = res.find((item: DDeclaracionSugerida) =>
          String(item.ideTipoRegistro) === TIPO_REG_DECLARACION_SUG_FACTURA_RENTA);

        if (!this.declaracionSugerida) {
          this.declaracionSugerida = res.find((item: DDeclaracionSugerida) =>
            String(item.ideTipoRegistro) === TIPO_REG_DECLARACION_SUG);
          alertaFactura = false;
        }

        //this.showFirstModalHelpDeclaracionSugerida(alertaFactura);
        if (alertaFactura) this._messagesObs.sendMessages('show-declasug', true);
        precargaProceso.close();
      }, error => {
        precargaProceso.close();
      }
    );
  } */

  public obtenerTRMCompleto(tasaCambioCompleto: DTasaCambioCompleto): void {
    this.dServiciosDiliParametricas.obtenerTasaDeCambioCompleto(tasaCambioCompleto.tasaCambioSolicitud.moneda, tasaCambioCompleto.fecha).subscribe(
      data => {
        this._messagesObs.sendMessages('trmCompleto', data);
      },
      error => {
        console.error(error);
        this._messagesObs.sendMessages('trmCompleto', null);
      }
    )
  }

  //Funciones inicializadoras de datos parametricos

  //Valor dominio 109
  private obtenerValorDominio109(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_109).subscribe(
      data => this.setObjectFromResponse(0, data),
      error => console.error(error)
    )
  }

  
  //Valor dominio 1630
  private obtenerValorDominio1630(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1630, null, null, null, POLITICA_1630_ORDER_FIELD, POLITICA_1630_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(1, data),
      error => console.error(error)
    )
    console.log(this.tiposParentesco);
  }

  //Valor dominio 1644
  private obtenerValorDominio1644(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1644, null, null, null, POLITICA_1644_ORDER_FIELD, POLITICA_1644_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(2, data),
      error => console.error(error)
    )
  }

  //UVT 
  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, this.getAnio()).subscribe(
      data => this.setObjectFromResponse(3, data),
      error => console.error(error)
    )
  }
  //Consultar NIT para Devoluciones
  private consultarNIT(): void {
    this.dServicioRESTAPI.consultarNit(this.modelo.doc.cab.cs_id_5).subscribe(
      data => this.setObjectFromResponse(9, data),
      error => console.log(error)
    )
  }

  //Actividades vigentes  
  private obtenerActividadesVigentes(): void {
    this.dServicioRESTAPI.consultarActividadesVigentes(String(this.getAnio())).subscribe(
      data => this.setObjectFromResponse(4, data),
      error => console.error(error)
    )
  }

  //Actividades economicas
  private obtenerActividadesEconomicasContribuyente(): void {
    this.dRutServicios.consultarActividadesEconomicasContribuyente(this.modelo.doc.cab.cs_id_5).subscribe(
      data => this.setObjectFromResponse(5, data),
      error => console.error(error)
    )
  }

  //Pago primera cuota
  private buscarPagosPrimeraCuota(): void {
    this.dServicioRESTAPI.pagosPrimeraCuota(this.modelo.doc.cab.cs_id_5, this.modelo.doc.cab.cs_id_1).subscribe(
      data => this.setObjectFromResponse(6, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1648
  private obtenerValorDominio1648(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1648).subscribe(
      data => this.setObjectFromResponse(7, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1655
  private obtenerValorDominio1655(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1655).subscribe(
      data => this.setObjectFromResponse(8, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1670 - Corresponde a dominio 3
  private obtenerValorDominio1670(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1670, null, null, null, POLITICA_GENERAL_ORDER_FIELD, POLITICA_GENERAL_ORDER_TYPE).subscribe(
      data => {
        this.setObjectFromResponse(10, data);
        console.log(data)
      },
      error => console.error(error)
    );     
  }

  private obtenerParametro(parametro: string): DParametroPolitica {
    for (let item of this.listaPoliticas.parametros) {
      if (item.nombre === parametro) 
        return item;
    }
    return null;
  }

  private obtenerValorPolitica318(): void {
    this.dBasicosParametricasServicios.obtenerPolitica(318).subscribe(
      res => {
        this.listaPoliticas =<DParametrosPolitica>res;
        this.parametroPoliticaAFC = this.obtenerParametro("TIPO_RENTA_RETIRO_CUENTAS_AFC_FVP_AVC");
        this.habilitaDevoluciones=this.obtenerParametro("HABILITA_DEVOLUCION").valor.toString()==='true'?true:false;
      },
      error => {
        console.error("Error consultado la politica ", error);
        //this._notifications.showError('Error obteniendo la politica ', error.descripcion);
      }
    );
  }

   //Valor dominio 1657
   private obtenerValorDominio1657(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1657, null, null, null, POLITICA_1657_ORDER_FIELD, POLITICA_1657_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(11, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1658
  private obtenerValorDominio1658(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1658, null, null, null, POLITICA_1658_ORDER_FIELD, POLITICA_1658_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(13, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1659
  private obtenerValorDominio1659(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1659, null, null, null, POLITICA_1659_ORDER_FIELD, POLITICA_1659_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(16, data),
      error => console.error(error)
    )
  }

  //Valor dominio 1660
  private obtenerValorDominio1660(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1660, null, null, null, POLITICA_1660_ORDER_FIELD, POLITICA_1660_ORDER_TYPE).subscribe(  
      data => {this.setObjectFromResponse(12, data)
        console.log(data)
      },

      error => console.error(error)
    )
        console.log(this.listaConcepIngresoGO)
  }

  //Valor dominio 1661
  private obtenerValorDominio1661(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1661, null, null, null, POLITICA_1661_ORDER_FIELD, POLITICA_1661_ORDER_TYPE).subscribe(  
      data => {this.setObjectFromResponse(14, data)
        console.log(data)
      },

      error => console.error(error)
    )
      /*   console.log(this.listaIngGOHerencia) */
  }

  //Valor dominio 1662
  private obtenerValorDominio1662(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1662).subscribe(
      data => {this.setObjectFromResponse(15, data)
        console.log(data)
      },

      error => console.error(error)
    )
        /* console.log(this.lisTipDeudaMonNal) */
  }

  //Valor dominio 1663
  private obtenerValorDominio1663(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1663).subscribe(
      data => {this.setObjectFromResponse(17, data)
        console.log(data)
      },

      error => console.error(error)
    )
      /*   console.log(this.lisTipRentaPasivaECE) */
  }

  //Valor dominio 1664
  private obtenerValorDominio1664(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1664,null,null,null,POLITICA_GENERAL_ORDER_FIELD,POLITICA_GENERAL_ORDER_TYPE).subscribe(
      data => {this.setObjectFromResponse(19, data)
        console.log(data)
      },

      error => console.error(error)
    )
       /*  console.log(this.listaConcDeduEspe) */
  }

  //Valor dominio 1665
  private obtenerValorDominio1665(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1665,null,null,null,POLITICA_GENERAL_ORDER_FIELD,POLITICA_GENERAL_ORDER_TYPE).subscribe(
      data => {this.setObjectFromResponse(18, data)
        console.log(data)
      },

      error => console.error(error)
    )
       /*  console.log(this.listaConcDeduEspe) */
  }

  //Valor dominio 1666
  private obtenerValorDominio1666(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1666,null,null,null,POLITICA_GENERAL_ORDER_FIELD,POLITICA_GENERAL_ORDER_TYPE).subscribe(
      data => {this.setObjectFromResponse(20, data)
        console.log(data)
      },

      error => console.error(error)
    )
       /*  console.log(this.listaConcDeduEspe) */
  }

  //Valor dominio 1667
  private obtenerValorDominio1667(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1667, null, null, null, POLITICA_1667_ORDER_FIELD, POLITICA_1667_ORDER_TYPE).subscribe(  
      data => {this.setObjectFromResponse(21, data)
        console.log(data)
      },

      error => console.error(error)
    )
        console.log(this.listaConcpRentaExenSinLimite)
  }

  //Valor dominio 1669 - Corresponde a dominio 20  
  private obtenerValorDominio1669(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1669).subscribe(
      data => this.setObjectFromResponse(22, data),
      error => console.error(error)
    );
  }

  //Valor dominio 1672 - Corresponde a dominio 26  
  private obtenerValorDominio1672(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1672).subscribe(
      data => this.setObjectFromResponse(23, data),
      error => console.error(error)
    );
  }

    //Valor dominio 1671 - Corresponde a dominio 17 rentas exentas de impuesto, pensión, cuentas AFC o cesantías  
    private obtenerValorDominio1671(): void {
      this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1671, null, null, null, POLITICA_1671_ORDER_FIELD, POLITICA_1671_ORDER_TYPE).subscribe(
        data => {this.setObjectFromResponse(25, data)
        console.log(data)
      },

      error => console.error(error)
    )
        console.log(this.conceptosRentasExentas)
  }

  //Valor dominio 1673 - Corresponde a dominio 24  
  private obtenerValorDominio1673(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1673).subscribe(
      data => this.setObjectFromResponse(24, data),
      error => console.error(error)
    );
  }

  //Valor dominio 1674 - Corresponde a dominio 25  
  private obtenerValorDominio1674(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1674).subscribe(
      data => this.listaAniosExtemporaneidad = <DValorDominio[]>data,
      error => console.error(error)
    );
  }

  //Valor dominio 1676 - Concepto ingresos no gravados con renta  
  private obtenerValorDominio1676(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1676, null, null, null, POLITICA_1676_ORDER_FIELD, POLITICA_1676_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(26, data),
      error => console.error(error)
    );
  }

  private getDataForm() {
    this.obtenerValorDominio109();
    this.obtenerValorDominio1630();
    this.obtenerValorDominio1644();
    this.obtenerValorPeriodico110();
    this.obtenerValorDominio1648();
    this.obtenerValorDominio1655();
    this.obtenerValorDominio1662();
    this.obtenerValorDominio1670();
    this.obtenerValorPolitica318();
    this.obtenerValorDominio1657();
    this.obtenerValorDominio1659();
    this.obtenerValorDominio1660();
    this.obtenerValorDominio1661();
    this.obtenerValorDominio1658();
    this.obtenerValorDominio1663();
    this.obtenerValorDominio1664(); 
    this.obtenerValorDominio1665();
    this.obtenerValorDominio1666();
    this.obtenerValorDominio1667();
    this.obtenerValorDominio1669();
    this.obtenerValorDominio1671();
    this.obtenerValorDominio1672();
    this.obtenerValorDominio1673();
    this.obtenerValorDominio1674();
    this.obtenerValorDominio1676();
    this.obtenerActividadesVigentes();
    this.obtenerActividadesEconomicasContribuyente();
    this.consultarNIT();

    if (this.dDatosCompartidosCabecera.concepto === "inicial")
      this.buscarPagosPrimeraCuota();
  }

  private setObjectFromResponse(id: number, data: any): void {
    switch (id) {
      case 0:
        this.tiposDocumento = <Array<DValorDominio>>data;
        this.logicaFiltroDocumentos();
        break;
      case 1:
        this.tiposParentesco = <Array<DValorDominio>>data;
        break;
      case 2:
        this.listaGenero = <Array<DValorDominio>>data;
        break;
      case 3:
        this.logicaUVT(<DValorPeriodico>data);
        break;
      case 4:
        this.listaActividadesEconomicasVigentes = data;
        break;
      case 5:
        if(data.length >0)
          {
          this.logicaActividadesEconomicas(<DActividadesEconomicas>data);
          this.actividadEconomica = data[0].id;
          }
        break;
      case 6:
        this.tienePrimeraCuota = <DObjetoPagoPrimeraCuota>data;
        this.logicaPrimeraCuota();
      //  this.validateGetSugerida();
        break;
      case 7:
        this.listaMoneda = <Array<DValorDominio>>data;
        break;
      case 8:
        this.listaModoAdquision = <Array<DValorDominio>>data;
        break;
      case 9:
        this.personaRUTJSON=<DDilPersonaRutJSON>data;
        break;
      case 10:
        this.listaTipRentaAFC = <Array<DValorDominio>>data;
        break;
      case 11:
        this.listaConceptosIng =<Array<DValorDominio>>data;
        break;
      case 12:
        this.listaConcepIngresoGO =<Array<DValorDominio>>data;
        break;  
      case 13:
        this.listaActiIng =<Array<DValorDominio>>data;
        break;
      case 14:
        this.listaIngGOHerencia =<Array<DValorDominio>>data;
        break;
      case 15:
        this.lisTipDeudaMonNal = <Array<DValorDominio>>data;
        break;  
      case 16:
        this.listaTipoPension = <Array<DValorDominio>>data;
        break;
      case 17:
        this.lisTipRentaPasivaECE = <Array<DValorDominio>>data;
        break;
      case 18:
        this.listaConcDeduEspe = <Array<DValorDominio>>data;
        break;
      case 19:
        this.listaAnioConstLiq = <Array<DValorDominio>>data;
        break;
      case 20:
        this.listConcDescTrib = <Array<DValorDominio>>data;
        break;
      case 21:
        this.listaConcpRentaExenSinLimite = <Array<DValorDominio>>data;
        break;
      case 22:
        this.listaTipoCompensaciones = <DValorDominio[]>data;
        break;
      case 23:
        this.listaTiposRentasLiquidasGravables = <DValorDominio[]>data;
        break;
      case 24:
        this.listaAniosDeclarados = <DValorDominio[]>data;
        break;      
      case 25:
        this.conceptosRentasExentas = <Array<DValorDominio>>data;
        break;  
      case 26:
        this.listaConceptosIngreNoGravados = <Array<DValorDominio>>data;
        break;      
    }
  }

  //Funciones negocio
  private logicaFiltroDocumentos() {
    this.tiposDocumentofiltrado = new Array<DValorDominio>();
    this.tiposDocumentofiltrado = this.tiposDocumento.filter((item) => DOCS_FILTER.includes(item.valor))
      .sort((a, b) => a.valor > b.valor ? 1 : a.valor < b.valor ? -1 : 0);
  }

  private logicaPrimeraCuota() {
    let idDocumentoDeclaracion = this.tienePrimeraCuota.ideDocumentoPago;
    if (this.modelo.doc.cab.cs_id_4 == null) {
      this.modelo.doc.cab.cs_id_4 = idDocumentoDeclaracion;
      this.dDatosCompartidosCabecera.numFormulario = idDocumentoDeclaracion;
    }
  }

  private logicaUVT(model: DValorPeriodico) {
    this.UVT = String(model.valor);
    //esta validacion se incluyo por los cambios en las formulas de las casilla 272 y 270, dado que habia inconsistencias en los valores de los documentos guardados antes del cambio en las declaraciones iniciales
    if ((
      this.dDatosCompartidosCabecera.concepto === "correccion" ||
      this.dDatosCompartidosCabecera.concepto === "fraccion_correccion") &&
      !this.modelo.doc.cab.cs_id_4
    ) this.operacionCs270(false);
  }

  private logicaActividadesEconomicas(list: DActividadesEconomicas) {
    const titleMessage = 'Tenga en cuenta';
    const textButton = 'Entendido';

    /*if (!list || !list.hasOwnProperty('0')) {
      this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
      return;
    }*/

    if (this.listaActividadesEconomicasVigentes) {
      const actividadEconomica = this.listaActividadesEconomicasVigentes.find((act: any) => list[0].id == act.codigo);
      if (actividadEconomica) {
        if ((!this.modelo.doc.cab.cs_id_4 || this.modelo.doc.cab.cs_id_4 == ""))
          this.modelo.doc.cuerpo.cs_id_24 = actividadEconomica.codigo;
      } /*else {
        if ((!this.modelo.doc.cuerpo.cs_id_24))
          this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
      }*/
    } //else this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
  }

  private setValuesDeclaracionSugerida() {
    //Cargar valores en el borrador        
    this.modelo.doc.cuerpo.cs_id_29 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla29, true);
    this.modelo.doc.cuerpo.cs_id_30 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla30, true);
    this.modelo.doc.cuerpo.cs_id_32 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla32, true);
    this.modelo.doc.cuerpo.cs_id_33 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla33, true);
    this.modelo.doc.cuerpo.cs_id_35 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla35, true);
    this.modelo.doc.cuerpo.cs_id_36 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla36, true);
    this.modelo.doc.cuerpo.cs_id_39 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla39, true);
    //  this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla41, true);
    this.modelo.doc.cuerpo.cs_id_43 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla43, true);
    this.modelo.doc.cuerpo.cs_id_44 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla44, true);
    this.modelo.doc.cuerpo.cs_id_47 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla47, true);
    this.modelo.doc.cuerpo.cs_id_48 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla48, true);
    this.modelo.doc.cuerpo.cs_id_51 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla51, true);
    // this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla53, true);
    this.modelo.doc.cuerpo.cs_id_58 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla58, true);
    this.modelo.doc.cuerpo.cs_id_59 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla59, true);
    this.modelo.doc.cuerpo.cs_id_63 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla63, true);
    this.modelo.doc.cuerpo.cs_id_64 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla64, true);
    this.modelo.doc.cuerpo.cs_id_67 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla67, true);
    // this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla69, true);
    this.modelo.doc.cuerpo.cs_id_74 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla74, true);
    this.modelo.doc.cuerpo.cs_id_76 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla76, true);
    this.modelo.doc.cuerpo.cs_id_80 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla80, true);
    this.modelo.doc.cuerpo.cs_id_81 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla81, true);
    this.modelo.doc.cuerpo.cs_id_84 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla84, true);
    // this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla86, true);
    this.modelo.doc.cuerpo.cs_id_98 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla98, true);
    this.modelo.doc.cuerpo.cs_id_99 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla99, true);
    this.modelo.doc.cuerpo.cs_id_100 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla100, true);
    this.modelo.doc.cuerpo.cs_id_102 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla102, true);
    this.modelo.doc.cuerpo.cs_id_104 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla104, true);
    this.modelo.doc.cuerpo.cs_id_105 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla105, true);
    this.modelo.doc.cuerpo.cs_id_107 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla107, true);
    this.modelo.doc.cuerpo.cs_id_108 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla108, true);
    this.modelo.doc.cuerpo.cs_id_110 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla110, true);
    this.modelo.doc.cuerpo.cs_id_111 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla111, true);
    this.modelo.doc.cuerpo.cs_id_123 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla123, true);
    this.modelo.doc.cuerpo.cs_id_124 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla124, true);
    this.modelo.doc.cuerpo.cs_id_125 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla125, true);
    this.modelo.doc.cuerpo.cs_id_131 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla131, true);
    this.modelo.doc.cuerpo.cs_id_132 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla132, true);
    this.modelo.doc.cuerpo.cs_id_133 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla133, true);
    this.modelo.doc.cuerpo.cs_id_134 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla134, true);
    //////////////////////////////////////////////////////////
    ////Agregado Factura Renta 18-08-2022
    this.modelo.doc.cuerpo.cs_id_38 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla38, true);
    this.modelo.doc.cuerpo.cs_id_45 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla45, true);
    this.modelo.doc.cuerpo.cs_id_50 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla50, true);
    this.modelo.doc.cuerpo.cs_id_56 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla56, true);
    this.modelo.doc.cuerpo.cs_id_60 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla60, true);
    this.modelo.doc.cuerpo.cs_id_62 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla62, true);
    this.modelo.doc.cuerpo.cs_id_66 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla66, true);
    this.modelo.doc.cuerpo.cs_id_72 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla72, true);
    this.modelo.doc.cuerpo.cs_id_75 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla75, true);
    this.modelo.doc.cuerpo.cs_id_77 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla77, true);
    this.modelo.doc.cuerpo.cs_id_79 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla79, true);
    this.modelo.doc.cuerpo.cs_id_83 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla83, true);
    this.modelo.doc.cuerpo.cs_id_89 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla89, true);
    this.modelo.doc.cuerpo.cs_id_94 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla94, true);
    this.modelo.doc.cuerpo.cs_id_95 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla95, true);
    this.modelo.doc.cuerpo.cs_id_96 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla96, true);
    this.modelo.doc.cuerpo.cs_id_109 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla109, true);
    this.modelo.doc.cuerpo.cs_id_112 = "0";//this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
    this.modelo.doc.cuerpo.cs_id_113 = "0";//this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla113, true);
    this.modelo.doc.cuerpo.cs_id_114 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla114, true);
    this.modelo.doc.cuerpo.cs_id_115 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla115, true);
    this.modelo.doc.cuerpo.cs_id_121 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla121, true);
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla127, true);
    this.modelo.doc.cuerpo.cs_id_128 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla128, true);
    this.modelo.doc.cuerpo.cs_id_129 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla129, true);
    this.recalcularFormulario();
  }

  private recalculoTemporales(): void {
    this.operacionCs270(true);
   
  }

  validarPregunta(idCasilla: number): void {
    let casillaPregunta = this.modelo.doc.cuerpo['cs_id_' + idCasilla];
    if (idCasilla != 299) {
      if (casillaPregunta == '0') {
        this.modelo.doc.cuerpo['cs_id_' + (idCasilla + 1)] = '0';
        this.recalculoTemporales();
      }
    }
    else {
      if (casillaPregunta == '0') {
        this.modelo.doc.cuerpo['cs_id_297'] = '0';
        this.recalculoTemporales();
      }
    }
  }

  validarPreguntas(definitivo?: boolean): void {
    //Set casilla genero
    this.modelo.doc.cuerpo.cs_id_286 = this.model2100.doc.cuerpo.cs_id_673;

    if (this.modelo.doc.cuerpo.cs_id_24 == "" || this.modelo.doc.cuerpo.cs_id_24 == null) {
      this.modelo.doc.cuerpo.cs_id_24 = "0010";
     
    }

 

    const validaGenero: string = this.modelo.doc.cuerpo['cs_id_286'];
    if (!validaGenero) {
      this._notifications.showInfo(MESSAGES.GENERO_OBLIGATORIO);
      return;
    }
  
    let validacion = true;
    let mensaje = "";
    const preguntas = [];

    preguntas.push({ casilla: "245", valor: this.modelo.doc.cuerpo.cs_id_246, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "247", valor: this.modelo.doc.cuerpo.cs_id_248, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "249", valor: this.modelo.doc.cuerpo.cs_id_250, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "251", valor: this.modelo.doc.cuerpo.cs_id_252, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "253", valor: this.modelo.doc.cuerpo.cs_id_254, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "282", valor: this.modelo.doc.cuerpo.cs_id_281, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "279", valor: this.modelo.doc.cuerpo.cs_id_280, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "255", valor: this.modelo.doc.cuerpo.cs_id_256, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74 });
    preguntas.push({ casilla: "277", valor: this.modelo.doc.cuerpo.cs_id_278, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74 });
    preguntas.push({ casilla: "275", valor: this.modelo.doc.cuerpo.cs_id_276, casillaControl: "58", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_58 });

    for (let pregunta of preguntas) {
      if (pregunta.valor == "" || pregunta.valor == "0" || pregunta.valor == null) {
        this.modelo.doc.cuerpo['cs_id_' + pregunta.casilla] = "0";
      } else if (pregunta.casilla != "27" && pregunta.valor == "1" && this.modelo.doc.cuerpo['cs_id_' + (Number(pregunta.casilla) + 1)] == "0") {
        mensaje = "Debo agregar un valor en la casilla " + (Number(pregunta.casilla) + 1) + ". Por favor verifique.";
        validacion = false;
        break;
      } else if (pregunta.valor == "1" && pregunta.valorCasillaControl == "0") {
        mensaje = "no puede contestar sí en la pregunta de la casilla " + pregunta.casilla + " por que, el valor de la casilla " + pregunta.casillaControl + " es 0. Por favor verifique.";
        validacion = false;
        break;
      }
    }

    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_525', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);

    //sumar 31,38,49 y comparar contra suma de preguntas
    const camposSumaIngresos = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74'];
    const resultadoSumaIngresos = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaIngresos, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, resultadoSumaIngresos)) {
      mensaje = MESSAGES.SUMATORIA_MAYOR_A_INGRESOS;
      validacion = false;
    }
////////////////////////////////////////////Operación en modo experto///////Habilitar si errores
/*if(!this.modo || this.modo=='experto')
{
    const cas41 = this.modelo.doc.cuerpo.cs_id_41;
    const cas53 = this.modelo.doc.cuerpo.cs_id_53;
    const cas69 = this.modelo.doc.cuerpo.cs_id_69;
    const cas86 = this.modelo.doc.cuerpo.cs_id_86;
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas49 = this.modelo.doc.cuerpo.cs_id_49;
    const cas52 = this.modelo.doc.cuerpo.cs_id_52;
    const cas65 = this.modelo.doc.cuerpo.cs_id_65;
    const cas68 = this.modelo.doc.cuerpo.cs_id_68;
    const cas82 = this.modelo.doc.cuerpo.cs_id_82;
    const cas85 = this.modelo.doc.cuerpo.cs_id_85;

    const suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);

    this.temporal41 = this.dutilidades.redondearValorMoneda(this.temporal41);
    this.temporal53 = this.dutilidades.redondearValorMoneda(this.temporal53);
    this.temporal69 = this.dutilidades.redondearValorMoneda(this.temporal69);
    this.temporal86 = this.dutilidades.redondearValorMoneda(this.temporal86);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas41, this.temporal41)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 41, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 35, 36, 38 o 39. El valor sugerido para la casilla 41 es: " + this.temporal41;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas53, this.temporal53)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 53, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 47, 48, 50 o 51. El valor sugerido para la casilla 53 es: " + this.temporal53;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas69, this.temporal69)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 69, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 63, 64, 66 o 67. El valor sugerido para la casilla 69 es: " + this.temporal69;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas86, this.temporal86)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 86, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 80, 81, 83 o 84. El valor sugerido para la casilla 86 es: " + this.temporal86;
      validacion = false;
    }
  }*/
  
    this.modelo.doc.cuerpo.cs_id_117 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_117);
    this.modelo.doc.cuerpo.cs_id_119 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_119);
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.modelo.doc.cuerpo.cs_id_130 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_130);
    this.modelo.doc.cuerpo.cs_id_271 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_271);
    this.modelo.doc.cuerpo.cs_id_272 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_272);
  
    this.modelo.doc.pie.cs_id_980 = this.dutilidades.deshacerFormatoMoneda(this.dutilidades.redondearValorMoneda(this.modelo.doc.pie.cs_id_980));

    if (validacion) {
      this.cambioFirma = false;
      if (definitivo) this.validarDeclaSugeridaGuardarDefinitivo();
      else this.validarDeclaSugeridaGuardar();
    } else this._notifications.showError(mensaje);
  }

  validarDeclaSugeridaPresentar() {
    if (this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    this.modelo.doc.cuerpo.cs_id_337 = '0';
    this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto
    this.presentarFormulario();

    let booltiensaldoafavor=false; 
    const cas137 =this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_137);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas137, "0"))
    {
      booltiensaldoafavor = true;
    }
    if(this.habilitaDevoluciones && booltiensaldoafavor)
      {
        this.validacionCandidato();
      }
    else
    {
      this.showPresentado();
      //this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.PRESENTADO);
    }
  }

  validarDeclaSugeridaGuardarDefinitivo() {
    if (this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    this.modelo.doc.cuerpo.cs_id_337 = '0';
    this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto
    this.guardarFormularioDefinitivo();
  }

  validarDeclaSugeridaGuardar() {
    if (this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    //Activa las notificaciones y loader del guardado por ser la ultima sección del formulario
    this.modelo.doc.cuerpo.cs_id_337 = '0';
    this.modelo.doc.cuerpo.cs_id_336 = '16500003'; //No experto
    this.procesarSinNotificaciones = this.indexStepper === 13 ? false : true;
    if (this.firmaRequerida && this.atributosDocumento.docAtributos.esPresentado) return;
    if (!this.firmaRequerida && this.atributosDocumento.docAtributos.esDefinitivo) return;
    this.guardarActualizarBorrador();
  }

  private actualizarDeclaracionSugerida(declaracionSugerida: any): void {
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    delete declaracionSugerida['status'];
    delete declaracionSugerida['statusText'];
    this.dServicioRESTAPI.actualizarDeclaracionSugerida(this.modelo.doc.cab.cs_id_5, declaracionSugerida).subscribe(
      res => precargaProceso.close(),
      error => precargaProceso.close()
    );
  }

  private asignarValoresRealesDeclaracionSugerida() {
    //actualizar valores reales    
    this.declaracionSugerida.valRealCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
    this.declaracionSugerida.valRealCasilla30 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_30);
    this.declaracionSugerida.valRealCasilla32 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32);
    this.declaracionSugerida.valRealCasilla33 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_33);
    this.declaracionSugerida.valRealCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
    this.declaracionSugerida.valRealCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
    this.declaracionSugerida.valRealCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
    //  this.declaracionSugerida.valRealCasilla41 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_41);
    this.declaracionSugerida.valRealCasilla43 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43);
    this.declaracionSugerida.valRealCasilla44 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_44);
    this.declaracionSugerida.valRealCasilla47 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_47);
    this.declaracionSugerida.valRealCasilla48 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_48);
    this.declaracionSugerida.valRealCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
    //  this.declaracionSugerida.valRealCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);  
    this.declaracionSugerida.valRealCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
    this.declaracionSugerida.valRealCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
    this.declaracionSugerida.valRealCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
    this.declaracionSugerida.valRealCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
    this.declaracionSugerida.valRealCasilla67 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_67);
    //  this.declaracionSugerida.valRealCasilla69 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_69);
    this.declaracionSugerida.valRealCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
    this.declaracionSugerida.valRealCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
    this.declaracionSugerida.valRealCasilla80 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_80);
    this.declaracionSugerida.valRealCasilla81 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_81);
    this.declaracionSugerida.valRealCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
    // this.declaracionSugerida.valRealCasilla86 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_86);  
    this.declaracionSugerida.valRealCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
    this.declaracionSugerida.valRealCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
    this.declaracionSugerida.valRealCasilla100 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_100);
    this.declaracionSugerida.valRealCasilla102 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_102);
    this.declaracionSugerida.valRealCasilla104 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
    this.declaracionSugerida.valRealCasilla105 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_105);
    this.declaracionSugerida.valRealCasilla107 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_107);
    this.declaracionSugerida.valRealCasilla108 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_108);
    this.declaracionSugerida.valRealCasilla110 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_110);
    this.declaracionSugerida.valRealCasilla111 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_111);
    this.declaracionSugerida.valRealCasilla123 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_123);
    this.declaracionSugerida.valRealCasilla124 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_124);
    this.declaracionSugerida.valRealCasilla125 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_125);
    this.declaracionSugerida.valRealCasilla131 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_131);
    this.declaracionSugerida.valRealCasilla132 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_132);
    this.declaracionSugerida.valRealCasilla133 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_133);
    this.declaracionSugerida.valRealCasilla134 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_134);
    /////////////////////////////////////////////////////////////////////////
    ////////Agregado Factura Renta 18-08-2022
    ////////////////////////////////////////////////////////////////////////
    this.declaracionSugerida.valRealCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
    this.declaracionSugerida.valRealCasilla45 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_45);
    this.declaracionSugerida.valRealCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
    this.declaracionSugerida.valRealCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
    this.declaracionSugerida.valRealCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
    this.declaracionSugerida.valRealCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
    this.declaracionSugerida.valRealCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
    this.declaracionSugerida.valRealCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
    this.declaracionSugerida.valRealCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
    this.declaracionSugerida.valRealCasilla77 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_77);
    this.declaracionSugerida.valRealCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
    this.declaracionSugerida.valRealCasilla83 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_83);
    this.declaracionSugerida.valRealCasilla89 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_89);
    this.declaracionSugerida.valRealCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
    this.declaracionSugerida.valRealCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
    this.declaracionSugerida.valRealCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
    this.declaracionSugerida.valRealCasilla109 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_109);
    this.declaracionSugerida.valRealCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valRealCasilla113 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_113);
    this.declaracionSugerida.valRealCasilla114 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_114);
    this.declaracionSugerida.valRealCasilla115 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_115);
    this.declaracionSugerida.valRealCasilla121 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.declaracionSugerida.valRealCasilla127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.declaracionSugerida.valRealCasilla128 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_128);
    this.declaracionSugerida.valRealCasilla129 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_129);

    
    this.declaracionSugerida.ideTipoDeclaracion = 34022891;
    this.modelo.doc.cuerpo.cs_id_285 = 'false';
    
    if (!this.declaracionSugerida.ideAceptacion)
      this.declaracionSugerida.ideAceptacion = 'S';
  }

  validarCambioFirma() {
    this.consultarFirmantes(false);
  }

  private recalcularFormulario(): void {
    this.boolfinal=true;
    this.operacionCs31();
    

    //RENTAS DE TRABAJO
    this.operacionCs32_33();
    //HONORARIOS
    this.operacionFinalsinRentas();
    this.operacionCs41();
    
    //CAPITAL
    this.operacionCs61();
    //RENTA NO LABORAL
    this.operacionCs78();
  ///Casillas postrior a dividendos 
    this.operacionCs106();
   
   this.boolfinal=false;
    //if(this.extemporaneidad.esExtemporaneo)
    //  this.sancionExtemporaneidad();
  }

  operPorcenDividendos(casilla: string) {
    const porcentaje: string = this.modelo.doc.cuerpo[casilla];
    let booporcentaje: boolean = false;
    for (let tipoPorcen of this.porcDividendos) {
      if (porcentaje == tipoPorcen) {
        booporcentaje = true;
        break;
      } else booporcentaje = false;
    }

    if (!booporcentaje) {
      this.dNotificacionServicio.mostrarDialogoError("El valor " + porcentaje + " Debe coincidir con los valores porcentuales");
      this.modelo.doc.cuerpo[casilla] = 0;
    }
  }

  operacionDividendos(tarifa: string, base: string, impuesto: string, operacion: boolean) {
    let porcentaje: string = this.modelo.doc.cuerpo[tarifa];
    porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, porcentaje, '100');
    let basemultiplica: string = this.modelo.doc.cuerpo[base];
    basemultiplica = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, basemultiplica, porcentaje);
    this.modelo.doc.cuerpo[impuesto] = basemultiplica;
    if(operacion)
    {
      this.operacionCs108();
      this.operacionCs121();
      this.operacionCs97();
    }
  }

 /* dividendosOtros(repeteciones: number) {
    let cuenta300: number = 304;
    this.strDividendosOtros = '<div fxLayout="row">';
    for (let cuenta = 1; cuenta <= repeteciones; cuenta++) {
      this.strDividendosOtros += '<div fxFlex><label for="cs_id_' + cuenta300 + '">' + cuenta300 + '. Tarifa ' + cuenta + ':  </label><input type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable' + cuenta300 + ' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros += 'focusable' + cuenta300 + ')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex> <label for="cs_id_' + cuenta300 + '">' + cuenta300 + '. Base ' + cuenta + ':  </label> <input type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable' + cuenta300 + ' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros += 'focusable' + cuenta300 + ')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex [mostrarAyuda]="modelo.doc.cab.cs_id_1" [idChild]="cs_id_76"> <label for="' + cuenta300 + '">' + cuenta300 + '. Impuesto dividendo ' + cuenta + ': </label> <input 	type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" disabled #focusable' + cuenta300 + ' [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" [mostrarAyuda]="modelo.doc.cab.cs_id_1">';
    }
    this.strDividendosOtros += '</div>';
  }*/

  descargarFormulario(): void {
    this.imprimirFormulario();
    //this._notifications.showInfo("Documento descargado con éxito", null, null, "Entendido");
  }

  liquidarPagarFormulario(): void {
    //Pago COP
    const precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioREST.generarLiquidacionReciboPago(this.modelo.doc.cab.cs_id_4).subscribe(
      res => {
        this.liquidacionRecigoPago = <DLiquidacionRecibo>res;
        this.indexSelectedTab = 5;
        this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        precarga.close();
      },
      error => {
        precarga.close();
        this._notifications.showError('No fue posible generar el recibo de pago.');
      });
  }

  descargarPDFPago(): void {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._restPago.descargarPDFReciboPago(String(this.reciboPago.ideDocumento))
      .subscribe(
        res => {
          let descarga: DRespuestaSimple = new DRespuestaSimple();
          descarga = res;
          const mediaType = 'application/pdf';
          const blob = new Blob([descarga.blob], { type: mediaType });
          const filename = this.reciboPago.ideDocumento + '.pdf';
          saveAs(blob, filename);
          preloader.close();
        },
        error => {
          this._notifications.showError('Error generando PDF', error.descripcion);
          preloader.close();
        }
      );
  }

  /////////Servicio de validaciónes devoluciones y redireccionamiento de pagina
  validacionCandidato() {
    const config = {
      personaRUT: this.personaRUTJSON,
      modelo: this.modelo.doc,
      contextoEstadoRUT: this.datosContexto.estadoRUT,
      booFraccion: this.booFraccion,
      esExtemporaneo: this.extemporaneidad.esExtemporaneo,
      tipoDocumento: this.datosContexto.tipoDocumento
    };
    let dialogDevoluciones = this.dialog.open(DevolucionesComponent);    
    dialogDevoluciones.componentInstance.data = config;

    dialogDevoluciones.afterClosed().subscribe(res => {
      if (!res) return;
      if (res.includes("http://") || res.includes("https://"))
        window.location.href = res;
     
    });
    
  } 

  //Funciones de operaciones de casillas
  operacionCs31(): void {
    const cas29 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_29, true);
    const cas30 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_30, true);
    const resultadoResta31 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas29, cas30, true);
    const resultadoOperacion31 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta31, "0") ? "0" : resultadoResta31;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion31, true);
    this.modelo.doc.cuerpo.cs_id_31 = String(valorRedondeado);
  }

  operacionCs34(): void {
    const cas32 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_32, true);
    const cas33 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_33, true);
    const resultadoResta34 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas32, cas33, true);
    const resultadoOperacion34 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta34, "0") ? "0" : resultadoResta34;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion34, true);
    this.modelo.doc.cuerpo.cs_id_34 = String(valorRedondeado);
    this.operacionCs37();
  }

  operacionCs37(): void {
    const cas35 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_35, true);
    const cas36 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_36, true);
    const resultadoResta37 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas35, cas36, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta37, true);
    this.modelo.doc.cuerpo.cs_id_37 = String(valorRedondeado);
    this.operacionCs40();
  }

  operacionCs40(): void {
    const cas38 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_38, true);
    const cas39 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_39, true);
    const resultadoResta40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas38, cas39, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta40, true);
    this.modelo.doc.cuerpo.cs_id_40 = String(valorRedondeado);
 //   this.operacionCs41();
  }

  operacionCs41(): void {
    this.operacionCs270(false);
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas34 = this.modelo.doc.cuerpo.cs_id_34;
    const cas273 = this.modelo.doc.cuerpo.cs_id_273;
    const resultadoSuma37y40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, resultadoSuma37y40, "0")) {
      this.modelo.doc.cuerpo.cs_id_41 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = resultadoSuma37y40;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    }

    this.operacionCs42();
   
  }

  operacionCs42(): void {
    const cas34 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_34, true);
    const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
    const resultadoResta42 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas34, cas41, true);
    const resultadoOperacion42 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta42, "0") ? "0" : resultadoResta42;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion42, true);
    this.modelo.doc.cuerpo.cs_id_42 = String(valorRedondeado);
   // this.operacionCs91();
   this. operacionCs46();
  }

  operacionCs46(): void {
    const camposResta = ['cs_id_44', 'cs_id_45'];
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_46 = valorRedondeado;
    //this.operacionCs53();
    this.operacionCs49();
  }

  operacionCs49(): void {
    const cas47 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_47, true);
    const cas48 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_48, true);
    const resultadoResta49 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas47, cas48, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta49, true);
    this.modelo.doc.cuerpo.cs_id_49 = String(valorRedondeado);
   // this.operacionCs53();
    if(this.dependiente10)
      this.operacionCs52();
    else
      this.operaciondependiente10xciento();
    this.dependiente10=false;
   
  }

  operacionCs52(): void {
    const cas50 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_50, true);
    const cas51 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_51, true);
    const resultadoResta52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas50, cas51, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta52, true);
    this.modelo.doc.cuerpo.cs_id_52 = String(valorRedondeado);
    this.operacionCs53();
   // this.operacionCs266();
  }

  operacionCs53(): void {
    this.operacionCs270(false);
    const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
    const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
    const cas46 = this.modelo.doc.cuerpo.cs_id_46;
    const cas265 = this.modelo.doc.cuerpo.cs_id_265;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma49_52, "0")) {
      this.modelo.doc.cuerpo.cs_id_53 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = suma49_52;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
    }

    this.operacionCs54();
   
  }

  operacionCs54(): void {
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const camposResta = ['cs_id_44', 'cs_id_45', 'cs_id_53'];
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_54 = valorRedondeado;
    this.operacionCs55();
  }

  operacionCs55(): void {
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const camposSuma = ['cs_id_44', 'cs_id_45'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, cas43, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_55 = valorRedondeado;
    this.operacionCs57();
  }

  operacionCs57(): void {
    const cas54 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_54, true);
    const cas56 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_56, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas54, cas56, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_57 = valorRedondeado;
    //this.operacionCs91();
  }

  operacionCs61(): void {
    const camposResta = ['cs_id_59', 'cs_id_60'];
    const cas58 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_58, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas58, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_61 = valorRedondeado;
    this.operacionCs65();
  }

  operacionCs65(): void {
    const cas63 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_63, true);
    const cas64 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_64, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas63, cas64, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_65 = valorRedondeado;
    this.operacionCs68();
    
  }

  operacionCs68(): void {
    const cas66 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_66, true);
    const cas67 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_67, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas66, cas67, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_68 = valorRedondeado;
    this.operacionCs69();
    //this.operacionCs55();
  }

  operacionCs69(): void {
    this.operacionCs270(false);
    const cas65 = this.modelo.doc.cuerpo.cs_id_65;
    const cas68 = this.modelo.doc.cuerpo.cs_id_68;
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
    const cas61 = this.modelo.doc.cuerpo.cs_id_61;
    const cas62 = this.modelo.doc.cuerpo.cs_id_62;
    const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true);
    const cas266 = this.modelo.doc.cuerpo.cs_id_266;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma65_68, "0")) {
      this.modelo.doc.cuerpo.cs_id_69 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = suma65_68;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    }
    this.operacionCs70();
   // this.operacionCs265();
  }

  operacionCs70(): void {
    const camposSuma = ['cs_id_58', 'cs_id_62'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_59', 'cs_id_60', 'cs_id_69'];
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_70 = valorRedondeado;
    this.operacionCs71();
  }

  operacionCs71(): void {
    const camposSuma = ['cs_id_59', 'cs_id_60'];
    const camposResta = ['cs_id_58', 'cs_id_62'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_71 = valorRedondeado;
    this.operacionCs72();
    
  }

  operacionCs72(): void {
    const cas70 = this.modelo.doc.cuerpo.cs_id_70;
    const cas72 = this.modelo.doc.cuerpo.cs_id_72;
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas72, cas70) ? cas70 : cas72 ;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_72 = valorRedondeado;
    this.operacionCs73();
  }

  operacionCs73(): void {
    const cas70 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_70, true);
    const cas72 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_72, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas70, cas72, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_73 = valorRedondeado;
   // this.operacionCs91();
  }

  operacionCs78(): void {
    const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
    const cas74 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_74, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas74, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_78 = valorRedondeado;
    this.operacionCs79();
    //this.operacionCs86();
  }

  operacionCs79(): void {
    this.operacionCs270(false);
    this.operacionCs82();
  }

  operacionCs82(): void {
    const cas80 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_80, true);
    const cas81 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_81, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas80, cas81, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_82 = valorRedondeado;
    this.operacionCs85();
  }

  operacionCs85(): void {
    const cas83 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_83, true);
    const cas84 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_84, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas83, cas84, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_85 = valorRedondeado;
    this.operacionCs86();
  }

  operacionCs86(): void {
    const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82);
    const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85);
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);
    const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78);
    const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79);
    const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true);
    const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma82_85, "0")) {
      this.modelo.doc.cuerpo.cs_id_86 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = suma82_85;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
    }

    this.operacionCs87();
  //  this.operacionCs270();
  }

  operacionCs87(): void {
    const camposSuma = ['cs_id_74', 'cs_id_79'];
    const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77', 'cs_id_86'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_87 = valorRedondeado;
    this.operacionCs88();
  }

  operacionCs88(): void {
    const camposSuma = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
    const camposResta = ['cs_id_74', 'cs_id_79'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_88 = valorRedondeado;
    this.operacionCs89();
 //   this.operacionCs90();
  }

  operacionCs89(): void {
    const cas87 = this.modelo.doc.cuerpo.cs_id_87;
    const cas89 = this.modelo.doc.cuerpo.cs_id_89;
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas89, cas87) ? cas87 : cas89 ;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_89 = valorRedondeado;
    this.operacionCs90();
  }

  operacionCs90(): void {
    const cas87 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_87, true);
    const cas89 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_89, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas87, cas89, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_90 = valorRedondeado;
    this.operacionCs91();
  }

  operacionCs91(): void {
    const camposSuma = ['cs_id_41', 'cs_id_42', 'cs_id_53', 'cs_id_57', 'cs_id_69', 'cs_id_73', 'cs_id_86', 'cs_id_90'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
    this.modelo.doc.cuerpo.cs_id_91 = valorRedondeado;
    this.operacionCs92();
  }

  operacionCs92(): void {
    this.operacionCs316();
    this.operacionCs139();
    let valorRedondeado = '0';
    const porcentaje297 = '0.01';
    const valoruvt240 = '240';
    let valorcasillaOperacion297 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
    let valorcasillaOperacion297p = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
    const UVT240 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt240, this.UVT);
    const mayorque = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorcasillaOperacion297, UVT240);

    if (mayorque) valorcasillaOperacion297 = UVT240;
    let valoredondeado28 = this.dutilidades.redondearValorMoneda(valorcasillaOperacion297p, true);
    
    
    const mayorque1 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valoredondeado28, UVT240);
    if (mayorque1) valoredondeado28 = UVT240;
    this.modelo.doc.cuerpo.cs_id_28 = valoredondeado28;
    const camposSuma = ['cs_id_41', 'cs_id_53', 'cs_id_69', 'cs_id_86','cs_id_28','cs_id_139'];
    let resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
    
    const cas91 =this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
    const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorRedondeado, cas91);
    if (mayorque2) this.modelo.doc.cuerpo.cs_id_92 = cas91;
    else this.modelo.doc.cuerpo.cs_id_92 = valorRedondeado;
    this.operacionCs93();
  }

  operacionCs93(): void {
    const cas91 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
    const cas92 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_92, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas91, cas92, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_93 = valorRedondeado;
    this.operacionCs94();
  }

  operacionCs94(): void {
    const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
    const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
    const cas42 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_42, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas42, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas94, resultadoResta)) {
      //this._notifications.showError("El valor de la casilla 94 no puede superar el valor de la casilla 93 menos la casilla 42");
      this.modelo.doc.cuerpo.cs_id_94 = "0";
    }
    this.operacionCs95();
  }

  operacionCs95(): void {
    const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
    const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
    const cas95 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_95, true);
    const resta93_94 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas94, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resta93_94, cas95)) {
      this._notifications.showError("El valor de la casilla 95 no puede superar el valor de la casilla 93 menos la casilla 94");
      this.modelo.doc.cuerpo.cs_id_95 = "0";
    }
    this.operacionCs97();
  }

 

  operacionCs97(): void {
    const camposSumaPrin = ['cs_id_93', 'cs_id_96'];
    const cas94 = this.modelo.doc.cuerpo.cs_id_94;
    const cas95 = this.modelo.doc.cuerpo.cs_id_95;
    const resultadoCamposSumaprin = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaPrin, true);
    const resultadoCamposResta1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaprin, cas94, true);
    const resultadoCamposResta2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposResta1, cas95, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta2, "0") ? "0" : resultadoCamposResta2;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_97 = valorRedondeado;
    this.operacionCs101();

}

  operacionCs101(): void {
    const cas99 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_99, true);
    const cas100 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_100, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas99, cas100, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_101 = valorRedondeado;
    this.operacionCs102();
  }

  operacionCs102(): void {
    const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
    const cas101 =  this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas102, cas101) ){
      this.dNotificacionServicio.mostrarDialogoInformacion("Señor contribuyente recuerde que el Limite de las rentas exentas por ingresos de pension por año no debe superar la renta líquida. El valor ingresado en esta casilla será ajustado al tope máximo permitido.");
      this.modelo.doc.cuerpo.cs_id_102 = this.modelo.doc.cuerpo.cs_id_101;
    }
    
    this.operacionCs103();
  }

  operacionCs103(): void {
    const cas101 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
    const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas101, cas102, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_103 = valorRedondeado;
   // this.operacionCs106();
  //  this.operacionCs111();
  }

  operacionCs106(): void {
    const cas104 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_104, true);
    const cas105 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_105, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas104, cas105, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_106 = valorRedondeado;
    this.operacionCs108();
  }

  operacionCs108(): void {
      const camposSumaDivi = ['cs_id_305', 'cs_id_308', 'cs_id_311', 'cs_id_314', 'cs_id_318', 'cs_id_321', 'cs_id_324', 'cs_id_327', 'cs_id_330', 'cs_id_333'];
      const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
      const camposSumaImpuestos= ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
      const resultadoCamposSumaImp = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaImpuestos, true);
      //const valorRedondeadoImp = this.dutilidades.redondearValorMoneda(resultadoCamposSumaImp);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSumaDiv);
     // const resta111 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorRedondeado, valorRedondeadoImp, true);
     // this.modelo.doc.cuerpo.cs_id_111 = resta111;
      this.modelo.doc.cuerpo.cs_id_108 = valorRedondeado;
      //this.operacionCs118();
     // this.operacionCs120();
      this.operacionCs114();
   
  }
  operacionCs111(): void {
    //this.operacionCs298();
    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);
    const cas107 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_107);
    const cas298 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_298);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
      const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97))  
    {
      const camposSuma= ['cs_id_98','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    } else {
      const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    }
   // this.operacionCs114();
    
  }
  public mensajeCs108()
  { 
    //this.operacionCs121();
    //this.booCas108Clic = true;
    this.dNotificacionServicio.mostrarDialogoConfirmacion('Para diligenciar el valor de la casilla 108 debe incluir los valores según lo requiera en las casillas  304, 305, 307, 308, 310, 311, 313, 314,  318, 319,  321, 322, 324, 325, 327, 328,  330,  331, 333,  334, en la siguiente pestaña');  
    return;
  }


  operacionCs114(): void {
    let cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112,true);
    let cas113 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_113,true);
    let cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114,true);
    let cas274 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_274,true);
    let resta112_114 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, cas113, true);

    resta112_114  = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resta112_114, "0") ? "0" : resta112_114;
    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas274, "0")){
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, "0")){
        //  this.dNotificacionServicio.mostrarDialogoError("Recuerde que  si en el periodo determinó pérdidas por ganancias ocasionales NO es procedente incluir en esta casilla ganancias ocasionales no gravadas y exentas, en caso de no tener pérdidas el valor incluido debe ser menor al valor de restar los costos al valor de  los ingresos");
          this.modelo.doc.cuerpo.cs_id_114 = "0"; 
        }
      }else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas274, "0") && (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, resta112_114))){
       // this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 114 no puede superar el valor de la casilla 112 menos la casilla 113");
        this.modelo.doc.cuerpo.cs_id_114 = "0";
      }
    this.operacionCs115();
  }

  operacionCs115(): void {
    const cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112);
    const camposSuma= ['cs_id_113','cs_id_114'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, resultadoCamposSuma, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta, "0")?"0":resultadoCamposResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_115 = valorRedondeado;
    this.operacionCs118();
   // this.operacionCs127();
  }

  operacionCs116(): void {

    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
      const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
      const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_116 = resultado;
   } else if ((this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, "0")) && 
    (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas98, "0"))) {
      const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
      const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_116 = resultado;
    }
   else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, cas98)) {
    const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
    const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_116 = resultado;
  }
    else {
      this.modelo.doc.cuerpo.cs_id_116 = "0";
    }
    this.operacionCs117();
  }

  operacionCs117(): void {
    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97)) {
      let resultadoCamposSumasec = "0";
      
      const cas111= this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111);
      const valorEnUvt = this.convertirPesosUvt(cas111);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_117 = resultado;
    } else {
      this.modelo.doc.cuerpo.cs_id_117 = "0";
    }
    //this.operacionCs118();
  }

  
  operacionCs118(): void { 
    
    const camposSumaRDivi = ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
    const resultadoCamposSumaRDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaRDivi, true);
  //  const resultadomas500 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoCamposSumaRDiv, this.suma500);
    let resultado=this.dutilidades.redondearValorMoneda(resultadoCamposSumaRDiv, true);
    this.modelo.doc.cuerpo.cs_id_118 = resultado; 
    this.operacionCs298();
    this.operacionCs119(true);   
    this.operacionCs296();
    
  }

  operacionCs119(booCalcula:Boolean): void {

    let cas106 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_106);
    let valorEnUvt = this.convertirPesosUvt(cas106);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ETNumeral2);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_119 = resultado;
    this.recalculoCasilla124();
    this.operacionCs120();
    if(!booCalcula)
    {
      this.operacionCs111();
    }

  }

  operacionCs120(): void {
     
      const cas109 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_109);
      const cas110 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_110);
      const suma109_110 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas109, cas110, true);
      const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma109_110, "0") ? "0" : suma109_110;
      const valC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoOperacion, this.tarifaA);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(valC, true);
      this.modelo.doc.cuerpo.cs_id_120 = valorRedondeado;
      
    
      this.operacionCs121();
     // this.operacionCs296();
     // this.operacionCs97();
  }

  operacionCs121(): void {
    const camposSuma = ['cs_id_116','cs_id_117','cs_id_118','cs_id_119', 'cs_id_120'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;
    this.operacionCs122();
  }

  operacionCs122(): void {
    const cas122 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_122);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas122, cas121)) {
      this._notifications.showError("El valor de la casilla 122 no puede superar el valor de la casilla 121");
      this.modelo.doc.cuerpo.cs_id_122 = "0";
    }
    this.operacionCs123();
  }

  operacionCs123(): void {
    const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
    const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    const cas123 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_123);
    const Cas121x30porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.30');
    const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
    this.modelo.doc.cuerpo.cs_id_123 = cas123;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x30porCien)) {
      this.modelo.doc.cuerpo.cs_id_123 = Cas121x30porCien;
      //this._notifications.showError("El valor de la casilla 123 no puede superar 30% del valor de la casilla 121");
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x25porCien)) {
      this.modelo.doc.cuerpo.cs_id_123 = Cas121x25porCien;
     // this._notifications.showError("El valor de la casilla 123 no puede superar 25% del valor de la casilla 121");
    } //else {
      
    this.operacionCs124();
    //}
  }

  operacionCs124(): void {
      //this.operacionCs296();
      const cas124=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_124);
      const cas296=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_296);
     
      if(cas124=='0')
      {
        this.modelo.doc.cuerpo.cs_id_124 = cas296;
      }
      else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas296, cas124))
      {
       // this._notifications.showError("El valor de la casilla 124 no puede ser inferior al valor de la casilla 296");
        this.modelo.doc.cuerpo.cs_id_124 = cas296;
      }
      this.operacionCs125();
  }

  operacionCs125(): void {
    const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
    const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    const camposSuma = ['cs_id_122', 'cs_id_123', 'cs_id_124'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125);
    const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
    this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) &&
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, cas121)) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, cas121)) {
        this._notifications.showError("El valor de la casilla 125 no puede superar el valor de la casilla 121");
        let valorRedondeado = this.dutilidades.redondearValorMoneda(cas121, true);
        this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
      }
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) &&
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, Cas121x25porCien)) {
      this._notifications.showError("El valor de la casilla 125 no puede superar 25% del valor de la casilla 121");
      let valorRedondeado = this.dutilidades.redondearValorMoneda(Cas121x25porCien, true);
      this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
    }
    this.operacionCs126();
  }

  operacionCs126(): void {
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
    const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
    let resultadoOperacion='0';
    if(this.boolfinal)
    {
      const resultadoValidacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, cas126) ? cas126 : resultadoResta;
      resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoValidacion, "0") ? "0" : resultadoValidacion;
    }
    else
    {
      resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    }
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
    this.operacionCs127();
    //this.operacionCs129();
  }
  

  operacionCs127(): void {
    const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
    const cas115VeintePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.2');

   // const cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114);
    const cas115QuincePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.14');

    const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

    let resultadoOperacion=cas127;

    if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas127,cas115QuincePorciento)) 
    {
      resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
    }
    else
     if ( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE,  cas127, cas115VeintePorciento))
     {
      resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
     }
    
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(resultadoOperacion);
    this.operacionCs129();
  }

  operacionCs129(): void {
    const camposSuma = ['cs_id_126', 'cs_id_127'];
    const cas128 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_128);
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas128, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_129 = valorRedondeado;
    //this.model2100.doc.cuerpo.cs_id_129 = valorRedondeado;
    this.operacionCs134();
  }

  operacionCs134(): void {
    const camposSuma = ['cs_id_129', 'cs_id_133'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_134 = valorRedondeado;
    this.operacionCs136();
  }

  operacionCs136(): void {
    const camposSuma = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_136 = valorRedondeado;
    this.operacionCs137();
  }

  operacionCs137(): void {
    const camposSuma = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_137 = valorRedondeado;
    this.operacionCs298();
  }

  private operacionCs287 () : void{
    if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
      this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" )
      {
        this.habilitaDependiente2 = false;
        if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 || Number(this.modelo.doc.cuerpo.cs_id_43)>0)
       {  
          this.habilitaDependiente5 = false;
         
       }
        this.contarDependientes();
        this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
      }
    else
    {
      this.habilitaDependiente2 = true;
    }
    this.operacionCs92();
  }
  operacionCs242(): void {
    this.modelo.doc.cuerpo.cs_id_335 = '0'; 
   // const cas355=Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_355));
    if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 || Number(this.modelo.doc.cuerpo.cs_id_43)>0)
    {
      this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"¿Desea aplicar un dependiente económico como deducción?").afterClosed().subscribe(result => {
        if (result) this.modelo.doc.cuerpo.cs_id_335 = '1';
        this.operacionCs92();
      });
    }
    
  }

  operacionCs265(): void {
    const cas273 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_273, true);
    const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas273, cas41, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_265 = valorRedondeado;

    const cas46 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_46);
    const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
    const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
    const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
        this.temporal53 = suma49_52;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
        this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
        this.temporal53 = cas265;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
        this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;;
      }
    }
    this.operacionCs266();
  }

  operacionCs266(): void {
    const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265, true);
    const cas53 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_53, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas265, cas53, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_266 = valorRedondeado;

    const cas61 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_61); //RENTA LIQUIDA
    const cas62 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_62); //RENTA LIQUIDA
    const cas65 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_65); //RENTAS EXCENTAS	
    const cas68 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_68); //DEDUCIONES IMPUTABLES
    const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266);
    const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true); //RENTAS LIQUIDAS PASIVAS
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true); //RENTAS EXCENTAS

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
        this.temporal69 = suma65_68;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
        this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
        this.temporal69 = cas266;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
        this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
      }
    }
    this.operacionCs267();
  }

  operacionCs267(): void {
    const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266, true);
    const cas69 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_69, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas266, cas69, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_267 = valorRedondeado;

    const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78); //RENTA LIQUIDA
    const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79); //RENTA LIQUIDA
    const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82); //RENTAS EXCENTAS	
    const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85); //DEDUCIONES IMPUTABLES
    const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);
    const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true); //RENTAS LIQUIDAS PASIVAS
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true); //RENTAS EXCENTAS

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
        this.temporal86 = suma82_85;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
        this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) ? suma78_79 : cas267;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma78_79, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
        this.temporal86 = cas267;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
        this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
      }
    }
  }

  operacionCs270(loopinicia:boolean): void {
    const camposSuma = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_33', 'cs_id_44', 'cs_id_59', 'cs_id_76'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_270 = valorRedondeado;
    this.operacionCs271(loopinicia);
  }

  operacionCs271(loopinicia:boolean): void {
    ////modificado 09-04-2024 tutela
    
    const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
    const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
    const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoPrimeraSuma, '0.40');
    
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    
    const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
    
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
    
    
    /*const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
    const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
    const camposResta = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const primerFactor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoPrimeraSuma, resultadoResta, true);
    const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, primerFactor, '0.40');
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
    */
    
    this.operacionCs272(loopinicia);
  }

  operacionCs272(loopinicia:boolean): void {
    let uvtDefecto = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.UVT, '1340');
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, uvtDefecto);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_272 = valorRedondeado;
    this.operacionCs273(loopinicia);
  }

  operacionCs273(loopinicia:boolean): void {
    this.operacionCs274();

    const cas270 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_270, true);
    const cas271 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_271, true);
    const cas272 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_272, true);

    const cas270Menorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas271);
    const cas270Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas272);
    const cas270Mayorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas271);
    const cas270Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas272);
    const cas270Iguala271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas271);
    const cas270Iguala272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas272);
    const cas271Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas271, cas272);
    const cas271Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas271, cas272);
    const cas270Menoigual272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas270, cas272);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, "0"))
      this.modelo.doc.cuerpo.cs_id_273 = "0";
    else if (cas270Menorq271 && cas270Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas270;
    else if (cas270Mayorq271 && cas270Menoigual272)
      this.modelo.doc.cuerpo.cs_id_273 = cas271;
    else if (cas270Mayorq271 && cas270Mayorq272 && cas271Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas271;
    else if (cas270Mayorq271 && cas270Mayorq272 && cas271Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Menorq271 && cas270Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas270;
    else if (cas270Menorq271 && cas270Iguala272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Iguala272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;

    const cas34 = this.modelo.doc.cuerpo.cs_id_34;
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas273 = this.modelo.doc.cuerpo.cs_id_273;
    const suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

    //validar cambios
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
        this.temporal41 = suma37_40;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
        this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
        this.temporal41 = cas273;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
        this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
      }
    }
    this.operacionCs265();
    
  }

  operacionCs274(): void {
      this.modelo.doc.cuerpo.cs_id_274 = "0";
     // this.operacionCs115();
   
  }

  operacionCs290(): void {
    if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
      this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != "") {
      this.habilitaDependiente3 = false;
      if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 || Number(this.modelo.doc.cuerpo.cs_id_43)>0 )
       {  
          this.habilitaDependiente5 = false;
         
       }
      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    }
    else {
      this.habilitaDependiente2 = true;
    }
    this.operacionCs92();
  }

  operacionCs293(): void {
    if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
      this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != "") {
      this.habilitaDependiente4 = false;
      if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 || Number(this.modelo.doc.cuerpo.cs_id_43)>0 )
       {  
          this.habilitaDependiente5 = false;
         
       }
      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    }
    else {
      this.habilitaDependiente2 = true;
    }
    this.operacionCs92();
  }
  operacionCs295(): void {
    if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
      this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != "") {
      this.contarDependientes(); 
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
      if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 || Number(this.modelo.doc.cuerpo.cs_id_43)>0 )
       {  
          this.habilitaDependiente5 = false;
         
       }
    }
    else {
      this.habilitaDependiente2 = true;
    }
    this.operacionCs92();
  }
  operacionCs358()
  {
    const cas358=this.modelo.doc.cuerpo.cs_id_358;

    const cas242=this.modelo.doc.cuerpo.cs_id_242;
    const cas288=this.modelo.doc.cuerpo.cs_id_288;
    const cas291=this.modelo.doc.cuerpo.cs_id_291;
    const cas294=this.modelo.doc.cuerpo.cs_id_294;
    let boolBuscaDependientes=false;
    if (this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_358 != "") 
    {
      if(cas358==cas242) boolBuscaDependientes=true;
      else if(cas358==cas288) boolBuscaDependientes=true;
      else if(cas358==cas291) boolBuscaDependientes=true;
      else if(cas358==cas294) boolBuscaDependientes=true;
    }
    else
    {
      boolBuscaDependientes=true; 
    }
    if(!boolBuscaDependientes)
     this._notifications.showError(MESSAGES.DEPENDIENTE);
    
     return boolBuscaDependientes;

  }
  operacionCs359()
  {
    if (this.modelo.doc.cuerpo.cs_id_357 != null && this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_359 != null &&
      this.modelo.doc.cuerpo.cs_id_357 != "" && this.modelo.doc.cuerpo.cs_id_358 != "" && this.modelo.doc.cuerpo.cs_id_359 != "") {
      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    }
    else {
      this.habilitaDependiente2 = true;
    }
    this.operacionCs92();

  }

  operacionCs296(): void {
    // const resultado1090UVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, '1090', this.UVT);
     
     //Modificación solicitada 27-03-2025
 
   const cas107UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_107);
   const cas108UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_108);
   const cas118UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_118);
   
   const suma107_108 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas107UVT, cas108UVT, false);
   const resta118 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, suma107_108, cas118UVT, false);
     /*const camposSumaDivi = ['cs_id_107', 'cs_id_108'];
     const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
     const cas118=this.modelo.doc.cuerpo.cs_id_118;
     let letCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaDiv, cas118, true);
     
     letCasilla296 = this.dutilidades.deshacerFormatoMoneda(letCasilla296);
     if (Number(resultado1090UVT) < Number(letCasilla296)) {
     */
   if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resta118, "1090")) {
       let resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resta118, '1090');
       resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoCasilla296, '0.19');
       const resultadoCasilla296SinUVT= this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoCasilla296, this.UVT);
       this.modelo.doc.cuerpo.cs_id_296 = this.dutilidades.redondearValorMoneda(resultadoCasilla296SinUVT, true);
     }
     else {
       this.modelo.doc.cuerpo.cs_id_296 = '0';
     }
     
  
   
   // this.operacionCs124();
  }

  operacionCs298(): void {
    let casilla303 ='0';
    let resultadoCasilla298 = '0';
    const cas118=this.modelo.doc.cuerpo.cs_id_118;
    const cas108=this.modelo.doc.cuerpo.cs_id_108;
    resultadoCasilla298 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas108, cas118);
    this.modelo.doc.cuerpo.cs_id_298 = resultadoCasilla298;
    if (this.modelo.doc.cuerpo.cs_id_43 != null && this.modelo.doc.cuerpo.cs_id_43 != '') {
      const casilla45 = this.modelo.doc.cuerpo.cs_id_45;
      const casilla43 = this.modelo.doc.cuerpo.cs_id_43;

      if (this.modelo.doc.cuerpo.cs_id_43 != '0')
        casilla303 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, casilla45, casilla43);
    }

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, casilla303, "0.6"))
      {
        this.booTopeindicativo = true;
        this.modelo.doc.cuerpo.cs_id_140='1';
      }
    else 
    {
      this.booTopeindicativo = false;
      this.modelo.doc.cuerpo.cs_id_140='0';
    }
    let dosDecCasilla303 =casilla303.substring(0,4);
    this.modelo.doc.cuerpo.cs_id_303 = dosDecCasilla303;
    this.operacionCs111();
    this.operacionCs116();
  }

  operacionCs316(): void {
    this.modelo.doc.cuerpo.cs_id_316 = 0;
  
  }
  operacionCs139(): void {
    this.modelo.doc.cuerpo.cs_id_139 = 0;
      const valoruvt72 = '72';
      const UVT72 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt72, this.UVT);
      if ((this.modelo.doc.cuerpo.cs_id_32 && this.modelo.doc.cuerpo.cs_id_32 != '0')
      || (this.modelo.doc.cuerpo.cs_id_43 && this.modelo.doc.cuerpo.cs_id_43 != '0'))
       {
        if (this.modelo.doc.cuerpo.cs_id_242 && this.modelo.doc.cuerpo.cs_id_242 != '') {
          this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
        }
        if (this.modelo.doc.cuerpo.cs_id_288 && this.modelo.doc.cuerpo.cs_id_288 != '') {
          this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
        }
        if (this.modelo.doc.cuerpo.cs_id_291 && this.modelo.doc.cuerpo.cs_id_291 != '') {
          this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
        }
        if (this.modelo.doc.cuerpo.cs_id_294 && this.modelo.doc.cuerpo.cs_id_294 != '') {
          this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
        }
      }
   //   if (this.modelo.doc.cuerpo.cs_id_335 && this.modelo.doc.cuerpo.cs_id_335 == '1') {
    //    this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
    //  }

      const camposSumaF = ['cs_id_42', 'cs_id_57','cs_id_41','cs_id_53'];
      let resultadoCamposSumaF = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaF, true);
      let valorRedondeado_42_57 = this.dutilidades.redondearValorMoneda(resultadoCamposSumaF, true);
      
      let cas139 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_139, true);
      const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas139, valorRedondeado_42_57);
      if (mayorque2) this.modelo.doc.cuerpo.cs_id_139 = valorRedondeado_42_57;
      else this.modelo.doc.cuerpo.cs_id_139 = cas139;

      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    
  }

  operacionCs980(): void {
    if (this.firmaRequerida) this.modelo.doc.pie.cs_id_980 = "0";
    const cas137 = this.modelo.doc.cuerpo.cs_id_137;
    let cas980 = this.modelo.doc.pie.cs_id_980;
    const comparacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas137, cas980) ? true : false;
    if (comparacion) {
      this._notifications.showError("Señor contribuyente, el valor de la casilla 980 (Pago total) no puede superar la suma de los valores de las casillas 135 (Saldo a pagar por impuesto) y 136 (Sanciones)");
      this.modelo.doc.pie.cs_id_980 = "0";
      return;
    }
    cas980 = this.dutilidades.redondearValorMoneda(this.modelo.doc.pie.cs_id_980);
    const cas980quitarFormato = this.dutilidades.deshacerFormatoMoneda(cas980);
    this.modelo.doc.pie.cs_id_980 = String(cas980quitarFormato);
  }

  //Operaciones de operaciones
  operacionCs32_33(): void {
    
    
    //casilla 32 se divide en 355 y 356 y se dehabilita 2024
    const cas355 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_355);
    const cas356 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_356);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas355, cas356, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_32 = valorRedondeado;

  //  this.operacionCs270();
    this.operacionCs34();
    
    
  }

 

  operacionCs58_59_60(): void {
  //  this.operacionCs270();
    this.operacionCs61();
  }

  operacionCs74_75_76(): void {
    this.operacionCs270(false);
    this.operacionCs78();
  }

  //Otras operaciones de cambio
  ingresoCs121(): void {
    this.calcularCas121 = false;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;
    this.operacionCs120();
  }

  cambioUsarioCs127(): void {
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
    const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas126, resultadoOperacion)) {
      this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
      this._notifications.showError("El valor de la casilla 126 no puede ser menor a la casilla 121 - casilla 125");
    }
    this.operacionCs127Cambio();
   // this.operacionCs129();
  }

  operacionCs127Cambio(): void {
    const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
    const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

    let porcentajeTopeMax = "0";
    let porcentajeTopeMin = "0";

      porcentajeTopeMin = "0.14";
      porcentajeTopeMax = "0.2";
    
    const cas115DiezPorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMin));
    const cas115MaxTopePorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMax));

    if (!(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas127, cas115DiezPorciento) &&
      (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas127, cas115MaxTopePorciento)))) {
      this.modelo.doc.cuerpo.cs_id_127 = cas115MaxTopePorciento;
      this._notifications.showError("El valor de la casilla 127 debe estar en un rango del " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMin, "100") + "% al " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMax, "100") + "% de la casilla 115");
    }
    this.operacionCs129();
  }


  

contarDependientes()
  {
    this.cuentadependientes=0;
    if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
      this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" )
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
      this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != "") 
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
        this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != "") 
      {
        
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
        this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != "") 
      {
          this.cuentadependientes++;
          
       }
     }

  mensajeAporte()
  {
    this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.APORTE_VOLUNTARIO);
    
  }
  private showPresentado()
  {
    this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: DialogsConfig.dialogoPresentado
    });
  }
  operacionFinalsinRentas()
  {
    if(this.modelo.doc.cuerpo.cs_id_32 ==='0')
    {
      this.modelo.doc.cuerpo.cs_id_33 ='0';
      this.modelo.doc.cuerpo.cs_id_35 ='0';
      this.modelo.doc.cuerpo.cs_id_36 ='0';
      this.modelo.doc.cuerpo.cs_id_38 ='0';
      this.modelo.doc.cuerpo.cs_id_39 ='0';
      
    }
    if(this.modelo.doc.cuerpo.cs_id_43 ==='0')
    { 
      this.modelo.doc.cuerpo.cs_id_44 ='0';
      this.modelo.doc.cuerpo.cs_id_47 ='0';
      this.modelo.doc.cuerpo.cs_id_48 ='0';
      this.modelo.doc.cuerpo.cs_id_50 ='0';
      this.modelo.doc.cuerpo.cs_id_51 ='0';
      this.operacionCs55();
    }
  }
  public verificaDisponiblidad()
  {
     //////Verifica si el formulario es permitido para su diligenciamiento
     if(this.anioDeclaracion !==2023 )
     {
       this.disponibilidad=false;
       let error:DError=new DError();
       error.codigo=520;
       error.mensaje='Formulario no disponible para Diligenciamiento';
       error.descripcion='Este formulario no se encuentra disponible para su diligenciamiento, por favor verifique su acceso' 
       let dialogo = this.dNotificacionServicio.mostrarDialogoError(error.mensaje, error.descripcion);
       dialogo.afterClosed().subscribe(res => {
        // window.history.back();
        this._location.back();
     });
     } 
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/formulario/formulario-no-experto.component.ts